import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type Airline = {
  __typename?: 'Airline';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  terminal?: Maybe<AirlineTerminal>;
};

export type AirlineTerminal = {
  __typename?: 'AirlineTerminal';
  domesticArrival?: Maybe<Scalars['String']['output']>;
  domesticDeparture?: Maybe<Scalars['String']['output']>;
  internationalArrival?: Maybe<Scalars['String']['output']>;
  internationalDeparture?: Maybe<Scalars['String']['output']>;
};

export type AttachCharterProfileResponse = MutationResponse & {
  __typename?: 'AttachCharterProfileResponse';
  auth?: Maybe<Auth>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AttachCouponResponse = MutationResponse & {
  __typename?: 'AttachCouponResponse';
  auth?: Maybe<Auth>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AttachGroupProfileResponse = MutationResponse & {
  __typename?: 'AttachGroupProfileResponse';
  auth?: Maybe<Auth>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AttachSalesProfileResponse = MutationResponse & {
  __typename?: 'AttachSalesProfileResponse';
  auth?: Maybe<Auth>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Auth = {
  __typename?: 'Auth';
  token?: Maybe<Scalars['String']['output']>;
};

/** Main input type for book mutation */
export type BookBookingType = {
  /** Contact information for the booking */
  contact?: InputMaybe<BookContactType>;
  /** Epic Pass ID */
  epicPassId?: InputMaybe<Scalars['String']['input']>;
  /** ID number */
  idNumber?: InputMaybe<Scalars['String']['input']>;
  /** Itinerary ID (if provided, will be used; otherwise omitted from Bridge request) */
  itineraryId?: InputMaybe<Scalars['String']['input']>;
  /** Array of reservation legs */
  legs: Array<InputMaybe<ResType>>;
  /** Who made the booking */
  madeBy?: InputMaybe<MadeByType>;
  /** Payment information */
  payment?: InputMaybe<PaymentType>;
};

/** Input type for booking contact information */
export type BookContactType = {
  altPhone?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  faxNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for credit card information */
export type BookCreditCardType = {
  /** Billing address */
  address?: InputMaybe<Scalars['String']['input']>;
  /** CVV (for temporary tokens) */
  cvv?: InputMaybe<Scalars['String']['input']>;
  /** Encrypted card number */
  encryptedCardNumber?: InputMaybe<Scalars['String']['input']>;
  /** Encrypted expiry month */
  encryptedExpiryMonth?: InputMaybe<Scalars['String']['input']>;
  /** Encrypted expiry year */
  encryptedExpiryYear?: InputMaybe<Scalars['String']['input']>;
  /** Encrypted security code */
  encryptedSecurityCode?: InputMaybe<Scalars['String']['input']>;
  /** Expiration date */
  expiration?: InputMaybe<Scalars['String']['input']>;
  /** Cardholder name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Last 4 digits of card number */
  numberLast4?: InputMaybe<Scalars['String']['input']>;
  /** Billing postal code */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** Processor ID */
  processorId?: InputMaybe<Scalars['Int']['input']>;
  /** Reference ID */
  refId?: InputMaybe<Scalars['String']['input']>;
  /** Credit card token */
  token?: InputMaybe<Scalars['String']['input']>;
  /** Token type (e.g., "temp" for temporary tokens) */
  tokenType?: InputMaybe<Scalars['String']['input']>;
  /** Card type code */
  typeCode?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for flight information */
export type BookFlightType = {
  airline?: InputMaybe<Scalars['String']['input']>;
  flightCity?: InputMaybe<Scalars['String']['input']>;
  flightNumber?: InputMaybe<Scalars['String']['input']>;
  flightTime?: InputMaybe<Scalars['String']['input']>;
  flightType?: InputMaybe<Scalars['String']['input']>;
  terminal?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for payment items on a leg */
export type BookLegPaymentItemType = {
  paymentAmount?: InputMaybe<Scalars['Float']['input']>;
  points?: InputMaybe<Scalars['Float']['input']>;
  programId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for leg payments (points/frequent rider) */
export type BookLegPaymentsType = {
  amountDue?: InputMaybe<Scalars['Float']['input']>;
  items?: InputMaybe<Array<InputMaybe<BookLegPaymentItemType>>>;
  totalPaymentAmount?: InputMaybe<Scalars['Float']['input']>;
};

/** Input type for location details */
export type BookLocType = {
  address?: InputMaybe<Scalars['String']['input']>;
  addressDetails?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  crossStreet?: InputMaybe<Scalars['String']['input']>;
  directions?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  latLng?: InputMaybe<LatLngInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  sector?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for passenger details */
export type BookPassengerDetailsType = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Response type for book mutation */
export type BookPayload = MutationResponse & {
  __typename?: 'BookPayload';
  /** General error message */
  error?: Maybe<Scalars['String']['output']>;
  /** Type of error if any */
  errorType?: Maybe<Scalars['String']['output']>;
  /** Itinerary ID for the booking */
  itineraryId?: Maybe<Scalars['String']['output']>;
  /** Human-readable message */
  message?: Maybe<Scalars['String']['output']>;
  /** Errors for each reservation */
  resErrors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** IDs of created reservations */
  resIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

/** Input type for booking stops */
export type BookStopType = {
  comments?: InputMaybe<Scalars['String']['input']>;
  directions?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<BookLocType>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Bridge = {
  __typename?: 'Bridge';
  address: Scalars['String']['output'];
  bridgeType?: Maybe<Scalars['Int']['output']>;
  exiRestartTOD?: Maybe<Scalars['String']['output']>;
  exiVersion?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  lastCheckTime?: Maybe<Scalars['String']['output']>;
  log: Array<BridgeLog>;
  parentId?: Maybe<Scalars['Int']['output']>;
  portNumber: Scalars['Int']['output'];
  server: Scalars['String']['output'];
  serviceName: Scalars['String']['output'];
  siteIds?: Maybe<Array<Scalars['String']['output']>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type BridgeLog = {
  __typename?: 'BridgeLog';
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  time: Scalars['String']['output'];
};

export type CancelResPayload = MutationResponse & {
  __typename?: 'CancelResPayload';
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum CardType {
  Amex = 'amex',
  Cup = 'cup',
  Diners = 'diners',
  Discover = 'discover',
  Enroute = 'enroute',
  Jcb = 'jcb',
  Mcard = 'mcard',
  Visa = 'visa'
}

/** A single check-in option returned by verifyRes for apps that support check-in */
export type CheckInOption = {
  __typename?: 'CheckInOption';
  /** The button label text */
  buttonCaption: Scalars['String']['output'];
  /** The command identifier (e.g., 'ReadyToGo', 'SoonToGo') - optional info */
  command?: Maybe<Scalars['String']['output']>;
  /** The hotkey ID to send to processHotkey */
  hotkeyId: Scalars['Int']['output'];
  /** The descriptive label explaining this option */
  label: Scalars['String']['output'];
};

/** Check-in options container returned when appName supports check-in */
export type CheckInOptions = {
  __typename?: 'CheckInOptions';
  /** Available check-in options for the user to select from */
  options: Array<CheckInOption>;
  /** Human-readable reservation summary */
  resSummary?: Maybe<Scalars['String']['output']>;
};

export enum CheckoutPickupTimeMode {
  /** Manual - Allow user to manually enter pickup time */
  Manual = 'manual',
  /** Normal - Show list of available pickup times */
  Normal = 'normal'
}

export type ClearBridgeCacheInput = {
  command?: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['String']['input'];
};

export type ClearBridgeCacheResponse = MutationResponse & {
  __typename?: 'ClearBridgeCacheResponse';
  command: Scalars['String']['output'];
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  siteId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type Colors = {
  __typename?: 'Colors';
  id: Scalars['String']['output'];
  primaryColor: Scalars['String']['output'];
  primaryHover: Scalars['String']['output'];
  primaryText: Scalars['String']['output'];
};

export enum ConfigMode {
  Clientcenter = 'CLIENTCENTER'
}

export type Configuration = {
  __typename?: 'Configuration';
  allowRouteLevelLocations: Scalars['Boolean']['output'];
  cashEnabled: Scalars['Boolean']['output'];
  creditCardCardsNotAccepted: Array<CardType>;
  creditCardEnabled: Scalars['Boolean']['output'];
  creditCardExternalUrl: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  /** @deprecated Use customerRequestMode instead */
  customerRequestEnabled: Scalars['Boolean']['output'];
  customerRequestMode: Scalars['Int']['output'];
  dateFormat: Scalars['String']['output'];
  dateOnlyBookingMode: Scalars['Boolean']['output'];
  defaultCcProcessorId: Scalars['Int']['output'];
  defaultPaymentType: Scalars['String']['output'];
  defaultRoundTrip: Scalars['Boolean']['output'];
  defaultSearchCenter: MapPoint;
  defaultServiceArea: Scalars['Int']['output'];
  directBillEnabled: Scalars['Boolean']['output'];
  disableProfileCreditCards: Scalars['Boolean']['output'];
  disableProfileLocations: Scalars['Boolean']['output'];
  enableFrequentRiderPurchase: Scalars['Boolean']['output'];
  enablePassengerDetails: Scalars['Boolean']['output'];
  enableProfileLinkedGroups: Scalars['Boolean']['output'];
  enableWebIdForLogin: Scalars['Boolean']['output'];
  epicPassEnabled: Scalars['Boolean']['output'];
  googleAnalyticsId: Scalars['String']['output'];
  googleApiKey: Scalars['String']['output'];
  googleMapsDisabled?: Maybe<Scalars['Boolean']['output']>;
  gratuityPercentages: Array<GratuityPercentage>;
  groupLoginEnabled: Scalars['Boolean']['output'];
  gtmId?: Maybe<Scalars['String']['output']>;
  hideCreateProfileSuggestion: Scalars['Boolean']['output'];
  hideDropoffTime: Scalars['Boolean']['output'];
  hideExtraStopsLocation: Scalars['Boolean']['output'];
  hideFlightNumber: Scalars['Boolean']['output'];
  hideFlightType: Scalars['Boolean']['output'];
  hideGroupProfileActions: Scalars['Boolean']['output'];
  hideLoginSuggestion: Scalars['Boolean']['output'];
  hidePickupTimeFlight: Scalars['Boolean']['output'];
  hideTerminal: Scalars['Boolean']['output'];
  hideUserProfileActions: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  imageBaseUrl: Scalars['String']['output'];
  initialDisplayedPickupTimes: Scalars['Int']['output'];
  jobType: Scalars['Int']['output'];
  linkedGroupFields: Array<Scalars['String']['output']>;
  locationBiasRadius: Scalars['Int']['output'];
  locationBiasStrictBounds: Scalars['Boolean']['output'];
  locationMode: LocationMode;
  locationTypeOptions: Array<LocationTypeOption>;
  lockGroupProfile: Scalars['Boolean']['output'];
  logoUrl: Scalars['String']['output'];
  marketingCodes: Array<FieldValue>;
  marketingCodes2: Array<FieldValue>;
  marketingCodes3: Array<FieldValue>;
  openReservationMode: OpenResMode;
  passengerDetailsRequired: Scalars['Boolean']['output'];
  pickupTimesDisplayOrder: Scalars['Int']['output'];
  profileLocationTypesList: Array<ProfileLocationTypeOption>;
  pudsAsPeople: Scalars['Boolean']['output'];
  requireCardOnFileCvv: Scalars['Boolean']['output'];
  requireLoginForBooking: Scalars['Boolean']['output'];
  resVerifyValidationModes: Array<FieldValue>;
  shopperReference?: Maybe<Scalars['String']['output']>;
  showCcaddress: Scalars['Boolean']['output'];
  showCcvv: Scalars['Boolean']['output'];
  showCczip: Scalars['Boolean']['output'];
  showCheckoutPointsSection: Scalars['Boolean']['output'];
  showCreditCardOnDirectBill: Scalars['Boolean']['output'];
  showExtraStopsComments: Scalars['Boolean']['output'];
  showExtraStopsName: Scalars['Boolean']['output'];
  showExtraStopsPudDirections: Scalars['Boolean']['output'];
  showGratuity: Scalars['Boolean']['output'];
  showMarketingCode: Scalars['Boolean']['output'];
  showMarketingCode2: Scalars['Boolean']['output'];
  showMarketingCode3: Scalars['Boolean']['output'];
  showMarketingCode3InCc: Scalars['Boolean']['output'];
  showProfileFrequentRiderPoints: Scalars['Boolean']['output'];
  singleServiceAutoSelect: Scalars['Boolean']['output'];
  specialInfoPassengerAlias?: Maybe<Scalars['String']['output']>;
  timeFormat: TimeFormat;
  topLocationsMode: TopLocationsMode;
  universalLocationsMode: Scalars['Boolean']['output'];
  useJsonCart: Scalars['Boolean']['output'];
};

export type ContactUpdateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  faxNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  newPassword?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  telephone2?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type ConvertResPayload = MutationResponse & {
  __typename?: 'ConvertResPayload';
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateDriverShiftInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  comments2?: InputMaybe<Scalars['String']['input']>;
  driverId: Scalars['Int']['input'];
  endMilage?: InputMaybe<Scalars['Float']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  scheduledEndTime: Scalars['String']['input'];
  scheduledStartTime: Scalars['String']['input'];
  startLocation?: InputMaybe<Scalars['String']['input']>;
  startMilage?: InputMaybe<Scalars['Float']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  vehicleId: Scalars['Int']['input'];
};

export type CreateDriverShiftPayload = MutationResponse & {
  __typename?: 'CreateDriverShiftPayload';
  driverShift?: Maybe<DriverShift>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Defaults = {
  __typename?: 'Defaults';
  creditCards?: Maybe<Array<TokenizedCreditCard>>;
  email?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  gratuityPercents?: Maybe<Array<Scalars['Float']['output']>>;
  id: Scalars['ID']['output'];
  marketingCode?: Maybe<Scalars['String']['output']>;
  marketingCode2?: Maybe<Scalars['String']['output']>;
  marketingCode3?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  telephone?: Maybe<Scalars['String']['output']>;
  telephone2?: Maybe<Scalars['String']['output']>;
};

export type Desktop = {
  __typename?: 'Desktop';
  fileName?: Maybe<Scalars['String']['output']>;
  hotkeyAlias?: Maybe<Scalars['String']['output']>;
  hotkeyColumnAlias?: Maybe<Scalars['String']['output']>;
  iconName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  remoteKey?: Maybe<Scalars['String']['output']>;
  rowDetailTemplate?: Maybe<Scalars['String']['output']>;
  rowsPerPage?: Maybe<Scalars['Int']['output']>;
  showRefresh?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type DesktopsReply = {
  __typename?: 'DesktopsReply';
  desktops?: Maybe<Array<Desktop>>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type DetachAllProfilesResponse = MutationResponse & {
  __typename?: 'DetachAllProfilesResponse';
  auth?: Maybe<Auth>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DetachCharterProfileResponse = MutationResponse & {
  __typename?: 'DetachCharterProfileResponse';
  auth?: Maybe<Auth>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DetachCouponResponse = MutationResponse & {
  __typename?: 'DetachCouponResponse';
  auth?: Maybe<Auth>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DetachGroupProfileResponse = MutationResponse & {
  __typename?: 'DetachGroupProfileResponse';
  auth?: Maybe<Auth>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DetachSalesProfileResponse = MutationResponse & {
  __typename?: 'DetachSalesProfileResponse';
  auth?: Maybe<Auth>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Driver information */
export type Driver = {
  __typename?: 'Driver';
  displayName: Scalars['String']['output'];
  employeeId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type DriverShift = {
  __typename?: 'DriverShift';
  comments?: Maybe<Scalars['String']['output']>;
  comments2?: Maybe<Scalars['String']['output']>;
  confirmed?: Maybe<Scalars['String']['output']>;
  driverId: Scalars['Int']['output'];
  endMilage?: Maybe<Scalars['Float']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastConfirmedTod?: Maybe<Scalars['String']['output']>;
  reportTod?: Maybe<Scalars['String']['output']>;
  scheduledEndTime: Scalars['String']['output'];
  scheduledStartTime: Scalars['String']['output'];
  startLocation?: Maybe<Scalars['String']['output']>;
  startMilage?: Maybe<Scalars['Float']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
  vehicleId: Scalars['String']['output'];
  vehicleName?: Maybe<Scalars['String']['output']>;
};

export type EpicPassReturn = {
  __typename?: 'EpicPassReturn';
  valid: Scalars['Boolean']['output'];
};

/** Return type for fare key lookup query */
export type FareKeyLookupReturn = {
  __typename?: 'FareKeyLookupReturn';
  /** Error indicator */
  error?: Maybe<Scalars['Boolean']['output']>;
  /** Detailed error message */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** JSON string of the request sent to backend (for debugging) */
  fklRequest?: Maybe<Scalars['String']['output']>;
  /** JSON string of the response from backend (for debugging) */
  fklResponse?: Maybe<Scalars['String']['output']>;
  /** Primary location match */
  location?: Maybe<Location>;
  /** Type of lookup performed */
  lookupType?: Maybe<Scalars['Int']['output']>;
  /** Array of nearby location matches */
  nearbyLocations?: Maybe<Array<Location>>;
};

export type FieldValue = {
  __typename?: 'FieldValue';
  field: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type FixedLocationType = {
  __typename?: 'FixedLocationType';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  locationCount: Scalars['Int']['output'];
  locations: Array<Location>;
  type: Scalars['String']['output'];
  typeString: Scalars['String']['output'];
};

export type FrequentRiderPoints = {
  __typename?: 'FrequentRiderPoints';
  availablePoints?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  programId?: Maybe<Scalars['Int']['output']>;
  totalCredits?: Maybe<Scalars['Float']['output']>;
  totalDebits?: Maybe<Scalars['Float']['output']>;
  transactions?: Maybe<Array<FrequentRiderPointsTransaction>>;
};

export type FrequentRiderPointsTransaction = {
  __typename?: 'FrequentRiderPointsTransaction';
  comments?: Maybe<Scalars['String']['output']>;
  debitCredit?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  expirationTod?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Scalars['Float']['output']>;
  programId?: Maybe<Scalars['Int']['output']>;
  redemptionType?: Maybe<Scalars['String']['output']>;
  resId?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transactionDate?: Maybe<Scalars['String']['output']>;
};

export type FrequentRiderProgram = {
  __typename?: 'FrequentRiderProgram';
  cost: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  paymentPointsPerFareUnit?: Maybe<Scalars['Int']['output']>;
  raw?: Maybe<Scalars['String']['output']>;
  redemptionDefaultDate?: Maybe<Scalars['String']['output']>;
  redemptionDuration?: Maybe<Scalars['String']['output']>;
  redemptionMaxUsage?: Maybe<Scalars['Int']['output']>;
  redemptionThreshold?: Maybe<Scalars['Int']['output']>;
  redemptionType: Scalars['String']['output'];
  sellFarePer?: Maybe<Scalars['Float']['output']>;
  sellMaxQuantity?: Maybe<Scalars['Int']['output']>;
  sellMinQuantity?: Maybe<Scalars['Int']['output']>;
  sellType?: Maybe<ProgramSellType>;
};

/** Response type for frequent rider program purchase mutation */
export type FrequentRiderProgramPurchasePayload = MutationResponse & {
  __typename?: 'FrequentRiderProgramPurchasePayload';
  /** Error type for categorizing the error */
  errorType?: Maybe<Scalars['String']['output']>;
  /** Human-readable message about the operation result */
  message?: Maybe<Scalars['String']['output']>;
  /** The reservation ID if the purchase was successful */
  resId?: Maybe<Scalars['String']['output']>;
  /** Indicates if the operation was successful */
  success: Scalars['Boolean']['output'];
};

/** Reservation details for frequent rider program purchase */
export type FrequentRiderProgramPurchaseResType = {
  /** Marketing codes for tracking */
  marketingCodes?: InputMaybe<MarketingCodesType>;
};

/**
 * Input type for frequent rider program purchase booking details
 * Matches Rails Types::FrequentRiderProgramPurchaseType
 */
export type FrequentRiderProgramPurchaseType = {
  /** Contact information for the purchase */
  contact?: InputMaybe<BookContactType>;
  /** Payment information for the purchase */
  payment: PaymentType;
  /** Marketing codes for tracking */
  res?: InputMaybe<FrequentRiderProgramPurchaseResType>;
};

export type Gdf = {
  __typename?: 'GDF';
  columnDefinitions?: Maybe<Array<GdfColumnDefinition>>;
  data?: Maybe<Array<GdfDataRow>>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  properties?: Maybe<GdfProperties>;
};

export type GdfCellStyleEntry = {
  __typename?: 'GDFCellStyleEntry';
  field: Scalars['String']['output'];
  style: GdfStyle;
};

export type GdfColumnDefinition = {
  __typename?: 'GDFColumnDefinition';
  dataFormat?: Maybe<Scalars['String']['output']>;
  dataType?: Maybe<Scalars['String']['output']>;
  dynaFilterType?: Maybe<Scalars['Int']['output']>;
  field: Scalars['String']['output'];
  hidden?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type GdfDataRow = {
  __typename?: 'GDFDataRow';
  cellStyles?: Maybe<Array<GdfCellStyleEntry>>;
  rowStyle?: Maybe<GdfStyle>;
  values: Array<Scalars['String']['output']>;
};

export type GdfProperties = {
  __typename?: 'GDFProperties';
  fileName: Scalars['String']['output'];
  gridType: Scalars['String']['output'];
  quickFilters?: Maybe<Array<GdfQuickFilter>>;
};

export type GdfQuickFilter = {
  __typename?: 'GDFQuickFilter';
  caption: Scalars['String']['output'];
  filterIndex: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
};

export type GdfStyle = {
  __typename?: 'GDFStyle';
  backColor: Scalars['String']['output'];
  bold: Scalars['Boolean']['output'];
  foreColor: Scalars['String']['output'];
  italic: Scalars['Boolean']['output'];
};

export type GratuityPercentage = {
  __typename?: 'GratuityPercentage';
  label?: Maybe<Scalars['String']['output']>;
  percent: Scalars['Float']['output'];
};

export type Hotkey = {
  __typename?: 'Hotkey';
  bgColor?: Maybe<Scalars['String']['output']>;
  caption: Scalars['String']['output'];
  functionCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  params?: Maybe<Scalars['String']['output']>;
  textColor?: Maybe<Scalars['String']['output']>;
  viewAlias: Scalars['String']['output'];
};

/**
 * One open field sent with a processHotkey call. Sent as a first-class JSON
 * field on the wire alongside the core fields.
 */
export type HotkeyFieldInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/**
 * Message-context fields sent with a processHotkey call (e.g. from the
 * messages grid composer). Each field is sent as a first-class JSON field on
 * the wire instead of being encoded into additionalParamString.
 */
export type HotkeyMessageInput = {
  /** The text of the message being sent */
  messageText?: InputMaybe<Scalars['String']['input']>;
  /** Identifier for the sender (e.g. the driver display name) */
  source?: InputMaybe<Scalars['String']['input']>;
};

export type HotkeysReply = {
  __typename?: 'HotkeysReply';
  error?: Maybe<Scalars['String']['output']>;
  hotkeys: Array<Hotkey>;
  id: Scalars['String']['output'];
};

/** Input type for field-value pairs used in fare components, passengers, and service extras */
export type InputFieldValueType = {
  field: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type KioskBookingsConfig = {
  __typename?: 'KioskBookingsConfig';
  defaultStandardTemplateId?: Maybe<Scalars['Int']['output']>;
  dropoffLocations?: Maybe<KioskDropoffLocationsConfig>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  pickupTime?: Maybe<KioskPickupTimeConfig>;
  requireStandardTemplates?: Maybe<Scalars['Boolean']['output']>;
  standardTemplateFilter?: Maybe<Scalars['String']['output']>;
};

export type KioskCheckInConfig = {
  __typename?: 'KioskCheckInConfig';
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type KioskConfig = {
  __typename?: 'KioskConfig';
  bookings?: Maybe<KioskBookingsConfig>;
  checkIn?: Maybe<KioskCheckInConfig>;
  id: Scalars['ID']['output'];
  webAppConfig?: Maybe<KioskWebAppConfig>;
};

/** Content type for kiosk application containing all available token fields */
export type KioskContent = {
  __typename?: 'KioskContent';
  id: Scalars['String']['output'];
  kioskBookBackButton?: Maybe<Scalars['String']['output']>;
  kioskBookButton?: Maybe<Scalars['String']['output']>;
  kioskBookContinueButton?: Maybe<Scalars['String']['output']>;
  kioskBookDropoffLabel?: Maybe<Scalars['String']['output']>;
  kioskBookDropoffPlaceholder?: Maybe<Scalars['String']['output']>;
  kioskBookEmailLabel?: Maybe<Scalars['String']['output']>;
  kioskBookNameLabel?: Maybe<Scalars['String']['output']>;
  kioskBookPassengerSection?: Maybe<Scalars['String']['output']>;
  kioskBookPhoneLabel?: Maybe<Scalars['String']['output']>;
  kioskBookSelectTemplate?: Maybe<Scalars['String']['output']>;
  kioskBookServiceSection?: Maybe<Scalars['String']['output']>;
  kioskBookSmsConsentLabel?: Maybe<Scalars['String']['output']>;
  kioskBookSubmitButton?: Maybe<Scalars['String']['output']>;
  kioskBookSuccessTitle?: Maybe<Scalars['String']['output']>;
  kioskBookTimeLabel?: Maybe<Scalars['String']['output']>;
  kioskBookTitle?: Maybe<Scalars['String']['output']>;
  kioskBookWarning?: Maybe<Scalars['String']['output']>;
  kioskCheckinButton?: Maybe<Scalars['String']['output']>;
  kioskCheckinConfirmButton?: Maybe<Scalars['String']['output']>;
  kioskCheckinEmailLabel?: Maybe<Scalars['String']['output']>;
  kioskCheckinFoundSubtitle?: Maybe<Scalars['String']['output']>;
  kioskCheckinFoundTitle?: Maybe<Scalars['String']['output']>;
  kioskCheckinResidLabel?: Maybe<Scalars['String']['output']>;
  kioskCheckinSearchAgainButton?: Maybe<Scalars['String']['output']>;
  kioskCheckinSubmitButton?: Maybe<Scalars['String']['output']>;
  kioskCheckinSubtitle?: Maybe<Scalars['String']['output']>;
  kioskCheckinSuccessTitle?: Maybe<Scalars['String']['output']>;
  kioskCheckinTitle?: Maybe<Scalars['String']['output']>;
  kioskErrCheckinFailed?: Maybe<Scalars['String']['output']>;
  kioskErrDropoffRequired?: Maybe<Scalars['String']['output']>;
  kioskErrEmailFormat?: Maybe<Scalars['String']['output']>;
  kioskErrEmailRequired?: Maybe<Scalars['String']['output']>;
  kioskErrNameRequired?: Maybe<Scalars['String']['output']>;
  kioskErrNoTemplates?: Maybe<Scalars['String']['output']>;
  kioskErrPhoneFormat?: Maybe<Scalars['String']['output']>;
  kioskErrPhoneRequired?: Maybe<Scalars['String']['output']>;
  kioskErrPickupTimeRequired?: Maybe<Scalars['String']['output']>;
  kioskErrResNotFound?: Maybe<Scalars['String']['output']>;
  kioskErrResidRequired?: Maybe<Scalars['String']['output']>;
  kioskErrSmsConsentRequired?: Maybe<Scalars['String']['output']>;
  kioskErrTemplatesLoad?: Maybe<Scalars['String']['output']>;
  kioskHeaderTitle?: Maybe<Scalars['String']['output']>;
  kioskLandingTitle?: Maybe<Scalars['String']['output']>;
  kioskNoFeaturesEnabled?: Maybe<Scalars['String']['output']>;
  kioskStartOverButton?: Maybe<Scalars['String']['output']>;
  kioskTimeoutContinueButton?: Maybe<Scalars['String']['output']>;
  kioskTimeoutWarningMessage?: Maybe<Scalars['String']['output']>;
  kioskTimeoutWarningTitle?: Maybe<Scalars['String']['output']>;
};

export type KioskDropoffLocation = {
  __typename?: 'KioskDropoffLocation';
  code: Scalars['String']['output'];
  fareType?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type KioskDropoffLocationsConfig = {
  __typename?: 'KioskDropoffLocationsConfig';
  defaultDropoffLocationCode?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  locations?: Maybe<Array<KioskDropoffLocation>>;
};

export type KioskPickupTimeConfig = {
  __typename?: 'KioskPickupTimeConfig';
  requestedPickupTimeInterval?: Maybe<Scalars['Int']['output']>;
  requestedPickupTimeMaxMinutes?: Maybe<Scalars['Int']['output']>;
  requestedPickupTimeOffset?: Maybe<Scalars['Int']['output']>;
};

export type KioskWebAppConfig = {
  __typename?: 'KioskWebAppConfig';
  requireEmailAddress?: Maybe<Scalars['Boolean']['output']>;
  requirePhoneNumber?: Maybe<Scalars['Boolean']['output']>;
};

/** Latitude and longitude coordinates */
export type LatLng = {
  __typename?: 'LatLng';
  /** Latitude coordinate */
  lat: Scalars['Float']['output'];
  /** Longitude coordinate */
  lng: Scalars['Float']['output'];
};

/** Input type for latitude/longitude coordinates */
export type LatLngInput = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

/** Represents a location in the system */
export type Location = {
  __typename?: 'Location';
  /** Street address */
  address?: Maybe<Scalars['String']['output']>;
  /** Additional address details */
  addressDetails?: Maybe<Scalars['String']['output']>;
  /** City name */
  city?: Maybe<Scalars['String']['output']>;
  /** Location code */
  code: Scalars['String']['output'];
  /** Country code */
  country?: Maybe<Scalars['String']['output']>;
  /** County name */
  county?: Maybe<Scalars['String']['output']>;
  /** Cross street information */
  crossStreet?: Maybe<Scalars['String']['output']>;
  /** Location description */
  description?: Maybe<Scalars['String']['output']>;
  /** Directions to the location */
  directions?: Maybe<Scalars['String']['output']>;
  /** Display address generated from location fields */
  displayAddress?: Maybe<Scalars['String']['output']>;
  /** Display name for the location */
  displayName: Scalars['String']['output'];
  /** Distance from a reference point */
  distance?: Maybe<Scalars['Float']['output']>;
  /** Fare key lookup request */
  fklRequest?: Maybe<Scalars['String']['output']>;
  /** Fare key lookup response */
  fklResponse?: Maybe<Scalars['String']['output']>;
  /** Full state name */
  fullState?: Maybe<Scalars['String']['output']>;
  /** Google Place ID for this location */
  googlePlaceId?: Maybe<Scalars['String']['output']>;
  /** Location icons */
  icons?: Maybe<Array<Scalars['String']['output']>>;
  /** Unique identifier for the location */
  id: Scalars['String']['output'];
  /** Latitude and longitude coordinates */
  latLng?: Maybe<LatLng>;
  /** Location metadata */
  metadata: Scalars['String']['output'];
  /** Name of the location */
  name: Scalars['String']['output'];
  /** Raw JSON data from Bridge API (for debugging) */
  raw?: Maybe<Scalars['String']['output']>;
  /** Whether cross street is required */
  requireCrossStreet?: Maybe<Scalars['Boolean']['output']>;
  /** Dispatching zone/sector */
  sector?: Maybe<Scalars['String']['output']>;
  /** Service areas this location belongs to */
  serviceAreas: Array<Scalars['Int']['output']>;
  /** Whether to show address details */
  showAddressDetails?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to show cross street for this location */
  showCrossStreet?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to show flight date */
  showFlightDate: Scalars['Boolean']['output'];
  /** Whether to show flight number for this location */
  showFlightNumber: Scalars['Boolean']['output'];
  /** Whether to show flight type */
  showFlightType: Scalars['Boolean']['output'];
  /** State or province code */
  state?: Maybe<Scalars['String']['output']>;
  /** String representation (purpose unclear - from Rails) */
  string?: Maybe<Scalars['String']['output']>;
  /** Contact telephone number */
  telephone?: Maybe<Scalars['String']['output']>;
  /** Whether this is a transportation hub */
  transportationHub: Scalars['Boolean']['output'];
  /** Type of location (A=Airport, H=Hotel, P=Locality, etc.) */
  type: Scalars['String']['output'];
  /** Human-readable type string (airport, hotel, locality, etc.) */
  typeString: Scalars['String']['output'];
  /** Postal code */
  zip?: Maybe<Scalars['String']['output']>;
};

/** Paginated list of locations */
export type LocationList = {
  __typename?: 'LocationList';
  /** Array of locations */
  locations: Array<Location>;
  /** Total number of pages */
  pages: Scalars['Int']['output'];
  /** Total number of items */
  totalItems: Scalars['Int']['output'];
};

export enum LocationMode {
  All = 'all',
  AllLocations = 'all_locations',
  None = 'none',
  UseConfig = 'use_config'
}

export type LocationTypeOption = {
  __typename?: 'LocationTypeOption';
  image?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type LoginUserPayload = MutationResponse & {
  __typename?: 'LoginUserPayload';
  auth?: Maybe<Auth>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type LoginUserProfileResponse = MutationResponse & {
  __typename?: 'LoginUserProfileResponse';
  auth?: Maybe<Auth>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type LogoutUserProfileResponse = MutationResponse & {
  __typename?: 'LogoutUserProfileResponse';
  auth?: Maybe<Auth>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type LogoutUserResponse = MutationResponse & {
  __typename?: 'LogoutUserResponse';
  auth?: Maybe<Auth>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Input type for who made the booking */
export type MadeByType = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type MapPoint = {
  __typename?: 'MapPoint';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** Input type for marketing codes */
export type MarketingCodesType = {
  marketingCode?: InputMaybe<Scalars['String']['input']>;
  marketingCode2?: InputMaybe<Scalars['String']['input']>;
  marketingCode3?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['String']['output']>;
  attachCharterProfile?: Maybe<AttachCharterProfileResponse>;
  attachCoupon?: Maybe<AttachCouponResponse>;
  attachGroupProfile?: Maybe<AttachGroupProfileResponse>;
  attachSalesProfile?: Maybe<AttachSalesProfileResponse>;
  /** Create a new booking with one or more reservation legs */
  book: BookPayload;
  cancelRes: CancelResPayload;
  clearBridgeCache: ClearBridgeCacheResponse;
  convertRes: ConvertResPayload;
  createDriverShift?: Maybe<CreateDriverShiftPayload>;
  detachAllProfiles?: Maybe<DetachAllProfilesResponse>;
  detachCharterProfile?: Maybe<DetachCharterProfileResponse>;
  detachCoupon?: Maybe<DetachCouponResponse>;
  detachGroupProfile?: Maybe<DetachGroupProfileResponse>;
  detachSalesProfile?: Maybe<DetachSalesProfileResponse>;
  /**
   * Purchase a frequent rider program with points or passes
   * Matches Rails Mutations::FrequentRiderProgramPurchase
   */
  frequentRiderProgramPurchase?: Maybe<FrequentRiderProgramPurchasePayload>;
  loginUser?: Maybe<LoginUserPayload>;
  loginUserProfile?: Maybe<LoginUserProfileResponse>;
  logoutUser?: Maybe<LogoutUserResponse>;
  logoutUserProfile?: Maybe<LogoutUserProfileResponse>;
  /** Process a hotkey action */
  processHotkey: ProcessHotkeyPayload;
  /**
   * Process a PID (encrypted parameter string) from client center.
   * - pid: The encrypted PID string
   * - forceGroup: When true, treats group codes as groups even if they have a couponType
   */
  processPid: ProcessPidPayload;
  profileAdd?: Maybe<ProfileAddPayload>;
  /**
   * Create a quote booking for kiosk (no payment required)
   * Uses NEWQUOTE operation - customer pays later via SMS/QuickPay
   */
  quote: QuotePayload;
  rateMyRideSubmit?: Maybe<RateMyRideSubmitPayload>;
  refreshToken?: Maybe<RefreshTokenPayload>;
  repriceService?: Maybe<RepriceServicePayload>;
  savePassword?: Maybe<SavePasswordPayload>;
  savePasswordWithPid?: Maybe<SavePasswordWithPidPayload>;
  /**
   * Sends a password reset email to the specified user
   *
   * This mutation initiates the password reset process by sending an email
   * with a reset link to the user's registered email address.
   */
  sendPasswordReset: SendPasswordResetPayload;
  setPasswordForProfile?: Maybe<SetPasswordForProfilePayload>;
  /** Tokenize credit card information for secure temporary storage */
  tokenize: TokenizePayload;
  updateDriverShift?: Maybe<UpdateDriverShiftPayload>;
  updateUserProfile?: Maybe<UpdateUserProfilePayload>;
  userProfileAddCc: UserProfileAddCcPayload;
  userProfileAddPud?: Maybe<UserProfileAddPudResponse>;
  userProfileAddValpayCc: UserProfileAddValpayCcPayload;
  userProfileDeleteCc: UserProfileDeleteCcPayload;
  /**
   * Delete a PUD (Preferred User Destination) from the user's profile.
   *
   * This mutation removes a saved pickup/dropoff location from the user's
   * list of preferred locations. The user profile is automatically determined
   * from the JWT authentication context.
   *
   * Note: This operation requires user authentication. The mutation will fail
   * if no valid user profile exists in the JWT context.
   */
  userProfileDeletePud: UserProfileDeletePudPayload;
  /**
   * Delete a credit card from a PUD (Preferred User Destination) in the user's profile.
   *
   * This mutation removes a saved credit card from a specific pickup/dropoff location
   * in the user's list of preferred locations. The user profile is automatically
   * determined from the JWT authentication context.
   *
   * Note: This operation requires user authentication. The mutation will fail
   * if no valid user profile exists in the JWT context.
   */
  userProfileDeletePudCc: UserProfileDeletePudCcPayload;
  /**
   * Link a user profile to a group with optional metadata.
   *
   * This mutation associates the authenticated user's profile with a group
   * and can store additional identifiers and custom data fields.
   * The user profile is automatically determined from the JWT authentication context.
   *
   * Note: This operation requires user authentication. The mutation will fail
   * if no valid user profile exists in the JWT context.
   */
  userProfileLinkGroup: UserProfileLinkGroupPayload;
  userProfileUpdatePud?: Maybe<UserProfileUpdatePudResponse>;
  validateUser?: Maybe<ValidateUserPayload>;
  verifyRes?: Maybe<VerifyResPayload>;
  /**
   * Verifies a reservation by email and returns check-in options.
   * Use this mutation when the user needs to select a check-in action.
   * After selection, call processHotkey with the chosen option's value.
   */
  verifyResForCheckIn?: Maybe<VerifyResForCheckInPayload>;
};


export type MutationAttachCharterProfileArgs = {
  id: Scalars['Int']['input'];
};


export type MutationAttachCouponArgs = {
  couponCode: Scalars['String']['input'];
  legs?: InputMaybe<Array<ServicesInput>>;
};


export type MutationAttachGroupProfileArgs = {
  id: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAttachSalesProfileArgs = {
  id: Scalars['Int']['input'];
};


export type MutationBookArgs = {
  booking: BookBookingType;
  sourceType?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCancelResArgs = {
  resId: Scalars['Int']['input'];
};


export type MutationClearBridgeCacheArgs = {
  input?: InputMaybe<ClearBridgeCacheInput>;
};


export type MutationConvertResArgs = {
  resId: Scalars['Int']['input'];
};


export type MutationCreateDriverShiftArgs = {
  input: CreateDriverShiftInput;
};


export type MutationFrequentRiderProgramPurchaseArgs = {
  booking: FrequentRiderProgramPurchaseType;
  frpProgramCost?: InputMaybe<Scalars['Float']['input']>;
  frpProgramEndDate?: InputMaybe<Scalars['String']['input']>;
  frpProgramId: Scalars['Int']['input'];
  frpProgramQuantity?: InputMaybe<Scalars['Int']['input']>;
  frpProgramStartDate?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationLoginUserArgs = {
  appType: UserApp;
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationLoginUserProfileArgs = {
  emailAddress: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationProcessHotkeyArgs = {
  input: ProcessHotkeyInput;
};


export type MutationProcessPidArgs = {
  forceGroup?: InputMaybe<Scalars['Boolean']['input']>;
  pid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProfileAddArgs = {
  input: ProfileAddInput;
};


export type MutationQuoteArgs = {
  alias: Scalars['String']['input'];
  booking: QuoteBookingType;
  sourceType?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRateMyRideSubmitArgs = {
  submission: RateMyRideSubmitInput;
};


export type MutationRepriceServiceArgs = {
  recalcEntireFare?: InputMaybe<Scalars['Boolean']['input']>;
  res: ServicesInput;
  sourceType?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSavePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationSavePasswordWithPidArgs = {
  password: Scalars['String']['input'];
  pid: Scalars['String']['input'];
};


export type MutationSendPasswordResetArgs = {
  resetPasswordUrl: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationSetPasswordForProfileArgs = {
  email: Scalars['String']['input'];
  linkedReservations?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  profileId: Scalars['Int']['input'];
  telephone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTokenizeArgs = {
  ccAddress?: InputMaybe<Scalars['String']['input']>;
  ccExpiration: Scalars['String']['input'];
  ccName?: InputMaybe<Scalars['String']['input']>;
  ccNumber: Scalars['String']['input'];
  ccPostalCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateDriverShiftArgs = {
  input: UpdateDriverShiftInput;
};


export type MutationUpdateUserProfileArgs = {
  contact?: InputMaybe<ContactUpdateInput>;
  linkedReservations?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationUserProfileAddCcArgs = {
  ccAddress?: InputMaybe<Scalars['String']['input']>;
  ccExpiration: Scalars['String']['input'];
  ccName: Scalars['String']['input'];
  ccNumber: Scalars['String']['input'];
  ccPostalCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUserProfileAddPudArgs = {
  location: ProfilePudInput;
};


export type MutationUserProfileAddValpayCcArgs = {
  ccCardHolderName?: InputMaybe<Scalars['String']['input']>;
  ccPostalCode?: InputMaybe<Scalars['String']['input']>;
  encryptedCardNumber: Scalars['String']['input'];
  encryptedExpiryMonth: Scalars['String']['input'];
  encryptedExpiryYear: Scalars['String']['input'];
  encryptedSecurityCode: Scalars['String']['input'];
};


export type MutationUserProfileDeleteCcArgs = {
  ccId?: InputMaybe<Scalars['Int']['input']>;
  ccLast4?: InputMaybe<Scalars['String']['input']>;
  ccRefId?: InputMaybe<Scalars['String']['input']>;
  ccToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUserProfileDeletePudArgs = {
  locationId: Scalars['Int']['input'];
};


export type MutationUserProfileDeletePudCcArgs = {
  ccId: Scalars['Int']['input'];
  pudId: Scalars['Int']['input'];
};


export type MutationUserProfileLinkGroupArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  data1?: InputMaybe<Scalars['String']['input']>;
  data2?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  webId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUserProfileUpdatePudArgs = {
  location: ProfilePudInput;
  pudId: Scalars['Int']['input'];
};


export type MutationValidateUserArgs = {
  appType: Scalars['String']['input'];
  password: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationVerifyResArgs = {
  resId: Scalars['String']['input'];
  validationMode: Scalars['String']['input'];
  validationValue: Scalars['String']['input'];
};


export type MutationVerifyResForCheckInArgs = {
  email: Scalars['String']['input'];
  resId: Scalars['String']['input'];
};

export type MutationResponse = {
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum OpenResMode {
  Disabled = 'disabled',
  Enabled = 'enabled',
  EnabledCollectDate = 'enabled_collect_date'
}

/** Represents a passenger type with its configuration */
export type PassengerType = {
  __typename?: 'PassengerType';
  /** Field name identifier for the passenger type */
  fieldName: Scalars['String']['output'];
  /** Unique identifier for the passenger type (matches fieldName for Rails compatibility) */
  id: Scalars['ID']['output'];
  /** Human-readable label for the passenger type */
  label: Scalars['String']['output'];
  /** Maximum number of passengers allowed for this type */
  maxPassengers: Scalars['Int']['output'];
  /** Optional popup text for additional information */
  popup?: Maybe<Scalars['String']['output']>;
  /** Raw JSON response from the backend (for debugging/compatibility) */
  raw?: Maybe<Scalars['String']['output']>;
};

/** Input type for booking payment information */
export type PaymentType = {
  /** Optional charge to value for direct bill */
  chargeTo?: InputMaybe<Scalars['String']['input']>;
  /** Credit card information */
  creditCard?: InputMaybe<BookCreditCardType>;
  /** Shopper reference for tokenization */
  shopperReference?: InputMaybe<Scalars['String']['input']>;
  /** Payment type */
  type?: InputMaybe<Scalars['String']['input']>;
  /** Payment type ID (e.g., "3" for DirectBill, "F" for FrequentRider) */
  typeId?: InputMaybe<Scalars['String']['input']>;
  /** Variance amount for edited reservations */
  variance?: InputMaybe<Scalars['Float']['input']>;
};

/** Represents a pickup extra option with its charge and configuration */
export type PickupExtra = {
  __typename?: 'PickupExtra';
  /** Additional charge amount for this pickup extra */
  charge?: Maybe<Scalars['Float']['output']>;
  /** Whether this pickup extra is selected by default */
  default?: Maybe<Scalars['Boolean']['output']>;
  /** Display name of the pickup extra */
  name?: Maybe<Scalars['String']['output']>;
  /** Value identifier for the pickup extra */
  value?: Maybe<Scalars['String']['output']>;
};

/** Input type for processHotkey mutation */
export type ProcessHotkeyInput = {
  /**
   * Open key/value fields spread flat into the Bridge requestData (e.g.
   * template input values keyed by section id). Keys colliding with core wire
   * fields are dropped server-side.
   */
  additionalFields?: InputMaybe<Array<HotkeyFieldInput>>;
  /** Optional additional parameter string */
  additionalParamString?: InputMaybe<Scalars['String']['input']>;
  /** Optional grid type the hotkey was triggered from (omitted for non-grid contexts like the sidebar) */
  gridType?: InputMaybe<Scalars['Int']['input']>;
  /** The ID of the hotkey to process */
  hotkeyId: Scalars['Int']['input'];
  /** Optional message-context fields sent when the hotkey originates from a messages grid */
  message?: InputMaybe<HotkeyMessageInput>;
  /** Optional reference ID */
  referenceId?: InputMaybe<Scalars['Int']['input']>;
};

/** Response type for processHotkey mutation */
export type ProcessHotkeyPayload = MutationResponse & {
  __typename?: 'ProcessHotkeyPayload';
  /** Error type if the operation failed */
  errorType?: Maybe<Scalars['String']['output']>;
  /** Human-readable message */
  message?: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type ProcessPidPayload = MutationResponse & {
  __typename?: 'ProcessPidPayload';
  auth?: Maybe<Auth>;
  decryptedParams?: Maybe<Scalars['String']['output']>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Profile = {
  __typename?: 'Profile';
  contactInfo?: Maybe<ProfileContact>;
  creditCards?: Maybe<Array<Maybe<TokenizedCreditCard>>>;
  id: Scalars['ID']['output'];
  linkedGroupName?: Maybe<Scalars['String']['output']>;
  locations?: Maybe<Array<Maybe<ProfileLocation>>>;
};

export type ProfileAddInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['Int']['input']>;
  linkedReservations?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  webId?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileAddPayload = MutationResponse & {
  __typename?: 'ProfileAddPayload';
  auth?: Maybe<Auth>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  profileId?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ProfileContact = {
  __typename?: 'ProfileContact';
  altPhone?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type ProfileLocation = {
  __typename?: 'ProfileLocation';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  creditCard?: Maybe<TokenizedCreditCard>;
  crossStreet?: Maybe<Scalars['String']['output']>;
  directions?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  latLng?: Maybe<LatLng>;
  locationType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pudName?: Maybe<Scalars['String']['output']>;
  sector?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  telephone?: Maybe<Scalars['String']['output']>;
  telephone2?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type ProfileLocationTypeOption = {
  __typename?: 'ProfileLocationTypeOption';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ProfilePudCreditCardInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  expiration: Scalars['String']['input'];
  name: Scalars['String']['input'];
  number: Scalars['String']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
};

export type ProfilePudInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  addressDetails?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  creditCard?: InputMaybe<ProfilePudCreditCardInput>;
  crossStreet?: InputMaybe<Scalars['String']['input']>;
  directions?: InputMaybe<Scalars['String']['input']>;
  displayAddress?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  faxNumber?: InputMaybe<Scalars['String']['input']>;
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  latLng?: InputMaybe<LatLngInput>;
  locationType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pudName?: InputMaybe<Scalars['String']['input']>;
  sector?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  telephone2?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for profile IDs */
export type ProfilesType = {
  charter?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  sales?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export enum ProgramSellType {
  Disabled = 'disabled',
  FixedViaTemplate = 'fixed_via_template',
  PerPoint = 'per_point',
  Unknown = 'unknown'
}

/** A person associated with a pickup/dropoff location (PUD) */
export type PudPerson = {
  __typename?: 'PudPerson';
  /** Address of the PUD location */
  address?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the PUD person */
  id: Scalars['ID']['output'];
  /** Name associated with the PUD location */
  name?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['String']['output']>;
  airlines: Array<Maybe<Airline>>;
  bridges: Array<Bridge>;
  colors?: Maybe<Colors>;
  config: Configuration;
  /** Get content tokens for a specific group */
  content?: Maybe<TokenContent>;
  defaults: Defaults;
  desktops: DesktopsReply;
  driverShift?: Maybe<DriverShift>;
  epicPassValidate: EpicPassReturn;
  epicPassValidateDate: EpicPassReturn;
  /**
   * Returns a Location object based on the incoming params and fare key lookup results.
   * If displayName/displayAddress are passed in they will be integrated into the Location.
   * Group profile is automatically taken from JWT context - do not pass as parameter.
   */
  fareKeyLookup: FareKeyLookupReturn;
  /**
   * Returns a list of location types with their associated locations.
   * Location types are filtered based on configuration settings and can include PUDs (Pick-Up/Drop-off locations).
   */
  fixedLocationTypes: Array<FixedLocationType>;
  frequentRiderPoints: Array<FrequentRiderPoints>;
  frequentRiderPrograms: Array<FrequentRiderProgram>;
  /** Fetch Grid Data Format (GDF) for driver desktop interfaces */
  gdf?: Maybe<Gdf>;
  hotkeys: HotkeysReply;
  /** Retrieve kiosk configuration for the given alias */
  kioskConfig?: Maybe<KioskConfig>;
  /** Retrieve content tokens for the kiosk application */
  kioskContent?: Maybe<KioskContent>;
  /**
   * Retrieves a single location by its fare code.
   * Service area can be provided to filter the location availability.
   * Group profile is automatically extracted from the JWT context.
   */
  location?: Maybe<Location>;
  /**
   * Get a filtered and paginated list of locations
   * Note: Profile parameters (charter, group, user) are taken from the JWT context
   */
  locationList: LocationList;
  /**
   * Locations especially filtered for autocomplete results.
   * Profiles (group, charter, user) are automatically extracted from JWT context.
   */
  locationsForAutocomplete: Array<Location>;
  /**
   * Returns a list of available passenger types.
   * Optionally filtered by service area or passenger type alias.
   */
  passengerTypes: Array<PassengerType>;
  /**
   * Get preferred locations (PUDs) for the authenticated user's profiles.
   * Returns locations from user, group, and charter profiles combined.
   * Locations without valid type configuration are filtered out.
   */
  profilePreferredLocations: Array<Maybe<Location>>;
  /**
   * Get reservations for the authenticated user profile.
   * Date range can be 'future', 'past', 'open', or omitted for all reservations.
   * Profile is automatically determined from the JWT context.
   */
  profileReservations: Array<Maybe<Reservation>>;
  /** People extracted from PUDs (pickup/dropoff locations) for the authenticated user */
  pudPeople: Array<PudPerson>;
  /** Fetch the Rate My Ride template by decrypting an encrypted PID. */
  rateMyRideTemplate?: Maybe<RateMyRideTemplate>;
  referralLinks: Array<ReferralLink>;
  /** Fetch a reservation template by decrypting an encrypted PID */
  resTemplate?: Maybe<ResTemplate>;
  /**
   * Retrieves a single reservation by its ID or PID.
   * Profile is automatically determined from the JWT context.
   * Returns null if the reservation is not found or does not belong to the authenticated profile.
   * When using a PID, the reservation is automatically trusted and accessible.
   */
  reservation?: Maybe<Reservation>;
  serviceAreas: Array<Maybe<ServiceArea>>;
  /**
   * Returns the site's configured service catalog as a flat list of
   * serviceType → name entries. Use this to translate the numeric
   * `ServiceType` codes that appear on trips and reservations into
   * human-readable labels. Sourced from the Bridge serviceConfig
   * command (cacheable).
   */
  serviceConfig: Array<ServiceConfigEntry>;
  serviceExtras: Array<ServiceExtra>;
  services: Array<Service>;
  /**
   * Get special information fields for the current site
   * Uses user and group profiles from JWT context
   */
  specialInfo: Array<SpecialInfoField>;
  /** Retrieve standard templates for the given alias */
  standardTemplates?: Maybe<Array<StandardTemplate>>;
  /** Retrieve all tokens for the booking engine */
  tokens: Array<Token>;
  /**
   * Returns the site's reference-data translation lists from the Bridge
   * `translations` command. Covers drivers, vehicles, payment types,
   * rider statuses, trip statuses, and other enum-like lists used across
   * reservations and trips grids. Header-only Bridge call — scoped per
   * site and language by context.
   */
  translations: Array<TranslationList>;
  userProfile?: Maybe<Profile>;
  /** Check if a user profile exists for the given email address */
  userProfileExists: UserProfileExists;
  /** Get Valpay configuration for Adyen payment processing */
  valpayConfig: ValpayConfig;
  /** List of GPS waypoints */
  waypoints: Array<Maybe<Waypoint>>;
};


export type QueryAirlinesArgs = {
  airportCode: Scalars['String']['input'];
  serviceAreaId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryConfigArgs = {
  mode?: InputMaybe<ConfigMode>;
  serviceAreaId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryContentArgs = {
  serviceAreaId?: InputMaybe<Scalars['Int']['input']>;
  showToken?: InputMaybe<Scalars['Boolean']['input']>;
  tokenGroup: Scalars['String']['input'];
};


export type QueryDefaultsArgs = {
  pudId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDriverShiftArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEpicPassValidateArgs = {
  passId: Scalars['String']['input'];
};


export type QueryEpicPassValidateDateArgs = {
  passId: Scalars['String']['input'];
  pickupDate: Scalars['String']['input'];
};


export type QueryFareKeyLookupArgs = {
  displayAddress?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  fareCode?: InputMaybe<Scalars['String']['input']>;
  googleObject?: InputMaybe<Scalars['String']['input']>;
  serviceAreaIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  sourceType?: InputMaybe<Scalars['Int']['input']>;
  typeString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFixedLocationTypesArgs = {
  hidePuds?: InputMaybe<Scalars['Boolean']['input']>;
  pudId?: InputMaybe<Scalars['Int']['input']>;
  serviceAreaId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFrequentRiderProgramsArgs = {
  redeemableForDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGdfArgs = {
  desktopId: Scalars['String']['input'];
  quickFilterId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryHotkeysArgs = {
  viewAlias: Scalars['String']['input'];
};


export type QueryKioskConfigArgs = {
  alias: Scalars['String']['input'];
};


export type QueryKioskContentArgs = {
  showToken?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLocationArgs = {
  fareCode: Scalars['String']['input'];
  serviceAreaId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLocationListArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  locationType: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  serviceAreaId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLocationsForAutocompleteArgs = {
  returnAll?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  serviceAreaId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPassengerTypesArgs = {
  passengerTypesAlias?: InputMaybe<Scalars['String']['input']>;
  serviceAreaId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProfileReservationsArgs = {
  dateRange?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRateMyRideTemplateArgs = {
  pid: Scalars['String']['input'];
};


export type QueryReferralLinksArgs = {
  flightCity?: InputMaybe<Scalars['String']['input']>;
};


export type QueryResTemplateArgs = {
  pid: Scalars['String']['input'];
};


export type QueryReservationArgs = {
  pid?: InputMaybe<Scalars['String']['input']>;
  reservationId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryServiceExtrasArgs = {
  serviceAreaId?: InputMaybe<Scalars['Int']['input']>;
  serviceExtrasAlias?: InputMaybe<Scalars['String']['input']>;
};


export type QueryServicesArgs = {
  res: ServicesInput;
  sourceType?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySpecialInfoArgs = {
  siAlias?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStandardTemplatesArgs = {
  alias: Scalars['String']['input'];
};


export type QueryUserProfileExistsArgs = {
  email: Scalars['String']['input'];
};


export type QueryValpayConfigArgs = {
  processorId?: InputMaybe<Scalars['Int']['input']>;
  shopperReference?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWaypointsArgs = {
  filters?: InputMaybe<Array<InputMaybe<WaypointFilterInput>>>;
};

/** Main input type for quote mutation */
export type QuoteBookingType = {
  /** Contact information for the booking */
  contact: QuoteContactType;
  /** Array of reservation legs */
  legs: Array<QuoteResType>;
};

/** Input type for quote booking contact information */
export type QuoteContactType = {
  altPhone?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

/** Input type for quote location (simplified for kiosk) */
export type QuoteLocType = {
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for quote passenger counts */
export type QuotePassengerType = {
  field: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/**
 * Response type for quote mutation
 * Note: NEWQUOTE operations don't return reservation IDs or itinerary IDs
 */
export type QuotePayload = MutationResponse & {
  __typename?: 'QuotePayload';
  /** General error message */
  error?: Maybe<Scalars['String']['output']>;
  /** Type of error if any */
  errorType?: Maybe<Scalars['String']['output']>;
  /** Human-readable message */
  message?: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

/** Input type for quote reservation leg (simplified for kiosk) */
export type QuoteResType = {
  /** Dropoff location */
  dropoff: QuoteLocType;
  /** Passenger counts */
  passengers?: InputMaybe<Array<InputMaybe<QuotePassengerType>>>;
  /** Pickup location (may be determined by standard template) */
  pickup?: InputMaybe<QuoteLocType>;
  /** Pickup time (ISO format) */
  pickupTime: Scalars['String']['input'];
  /** Standard template ID */
  standardTemplateId?: InputMaybe<Scalars['Int']['input']>;
};

export type RateMyRideSubmitInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  creditCard?: InputMaybe<RmrCreditCardInput>;
  gratuity?: InputMaybe<Scalars['Float']['input']>;
  /** Encrypted PID; the resolver re-derives the reservation id from it. */
  pid: Scalars['String']['input'];
  ratings?: InputMaybe<Array<RatingInput>>;
};

export type RateMyRideSubmitPayload = {
  __typename?: 'RateMyRideSubmitPayload';
  error?: Maybe<Scalars['String']['output']>;
  externalURL?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  successMessage?: Maybe<Scalars['String']['output']>;
};

export type RateMyRideTemplate = {
  __typename?: 'RateMyRideTemplate';
  /** Per-reservation banner message (not a content token). */
  displayedMessage?: Maybe<Scalars['String']['output']>;
  gratuityPercentages?: Maybe<Array<RmrGratuityPercentage>>;
  options?: Maybe<RmrOptions>;
  ratingCategories?: Maybe<Array<RatingCategory>>;
  reservation?: Maybe<RmrReservation>;
};

/** A dynamic rating category. `name` is the submit key (e.g. "resIndicator"). */
export type RatingCategory = {
  __typename?: 'RatingCategory';
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** A single rating category submission (e.g. { name: "resIndicator", value: 5 }). */
export type RatingInput = {
  name: Scalars['String']['input'];
  value: Scalars['Int']['input'];
};

export type ReferralLink = {
  __typename?: 'ReferralLink';
  alias: Scalars['String']['output'];
  boldText?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  linkText?: Maybe<Scalars['String']['output']>;
  linkUrl?: Maybe<Scalars['String']['output']>;
  popup?: Maybe<Scalars['String']['output']>;
  priority: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
  webItems?: Maybe<Array<Scalars['String']['output']>>;
};

export type RefreshTokenPayload = MutationResponse & {
  __typename?: 'RefreshTokenPayload';
  auth?: Maybe<Auth>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Reprice = {
  __typename?: 'Reprice';
  bagCountMax?: Maybe<Scalars['Int']['output']>;
  fareComponents?: Maybe<Array<FieldValue>>;
  fareDisplay?: Maybe<Scalars['Float']['output']>;
  gratuityFare?: Maybe<Scalars['Float']['output']>;
  originalFare?: Maybe<Scalars['Float']['output']>;
  payments?: Maybe<RepricePayment>;
  times?: Maybe<Array<ServiceTime>>;
  webSubfares?: Maybe<Array<FieldValue>>;
};

export type RepricePayment = {
  __typename?: 'RepricePayment';
  amountDue?: Maybe<Scalars['Float']['output']>;
  items?: Maybe<Array<RepricePaymentItem>>;
  totalPaymentAmount?: Maybe<Scalars['Float']['output']>;
};

export type RepricePaymentItem = {
  __typename?: 'RepricePaymentItem';
  paymentAmount?: Maybe<Scalars['Float']['output']>;
  points?: Maybe<Scalars['Float']['output']>;
  programId?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type RepriceServicePayload = MutationResponse & {
  __typename?: 'RepriceServicePayload';
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  reprice?: Maybe<Reprice>;
  success: Scalars['Boolean']['output'];
};

export type ResContact = {
  __typename?: 'ResContact';
  altPhone?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type ResCreditCard = {
  __typename?: 'ResCreditCard';
  expiration?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numberLast4?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  typeCode?: Maybe<Scalars['String']['output']>;
};

export type ResFieldValue = {
  __typename?: 'ResFieldValue';
  field: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type ResFlight = {
  __typename?: 'ResFlight';
  airline?: Maybe<Scalars['String']['output']>;
  flightCity?: Maybe<Scalars['String']['output']>;
  flightNumber?: Maybe<Scalars['String']['output']>;
  flightTime?: Maybe<Scalars['String']['output']>;
  flightType?: Maybe<Scalars['String']['output']>;
  terminal?: Maybe<Scalars['String']['output']>;
};

export type ResMadeBy = {
  __typename?: 'ResMadeBy';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type ResOptions = {
  __typename?: 'ResOptions';
  allowOpenResConversion: Scalars['Boolean']['output'];
};

export type ResOther = {
  __typename?: 'ResOther';
  idNumber?: Maybe<Scalars['String']['output']>;
  madeBy?: Maybe<ResMadeBy>;
  marketingCode?: Maybe<Scalars['String']['output']>;
  marketingCode2?: Maybe<Scalars['String']['output']>;
  marketingCode3?: Maybe<Scalars['String']['output']>;
  specialInstructions?: Maybe<Scalars['String']['output']>;
  specialInstructions2?: Maybe<Scalars['String']['output']>;
};

export type ResPayment = {
  __typename?: 'ResPayment';
  chargeTo?: Maybe<Scalars['String']['output']>;
  creditCard?: Maybe<ResCreditCard>;
  shopperReference?: Maybe<Scalars['String']['output']>;
  typeId?: Maybe<Scalars['String']['output']>;
  variance?: Maybe<Scalars['Float']['output']>;
};

export type ResProfiles = {
  __typename?: 'ResProfiles';
  charter?: Maybe<Scalars['Int']['output']>;
  coupon?: Maybe<Scalars['Int']['output']>;
  group?: Maybe<Scalars['Int']['output']>;
  sales?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<Scalars['Int']['output']>;
};

export type ResStop = {
  __typename?: 'ResStop';
  comments?: Maybe<Scalars['String']['output']>;
  directions?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ResTemplate = {
  __typename?: 'ResTemplate';
  body?: Maybe<ResTemplateBody>;
  metadata?: Maybe<ResTemplateMetadata>;
  resId?: Maybe<Scalars['Int']['output']>;
};

export type ResTemplateBody = {
  __typename?: 'ResTemplateBody';
  content?: Maybe<ResTemplateContent>;
  header?: Maybe<ResTemplateHeader>;
  options?: Maybe<Array<ResTemplateOption>>;
};

export type ResTemplateContent = {
  __typename?: 'ResTemplateContent';
  sections?: Maybe<Array<ResTemplateSection>>;
};

export type ResTemplateHeader = {
  __typename?: 'ResTemplateHeader';
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ResTemplateMetadata = {
  __typename?: 'ResTemplateMetadata';
  author?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type ResTemplateOption = {
  __typename?: 'ResTemplateOption';
  /**
   * Default param values for this option. Keys match input section ids;
   * user-entered values override these at submit time.
   */
  additionalParams?: Maybe<Array<ResTemplateOptionParam>>;
  buttonCaption?: Maybe<Scalars['String']['output']>;
  functionCode?: Maybe<Scalars['Int']['output']>;
  /** Grid type forwarded verbatim onto the processHotkey mutation. */
  gridType?: Maybe<Scalars['Int']['output']>;
  hotkeyId?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

/** A default param value submitted with an option's hotkey press. */
export type ResTemplateOptionParam = {
  __typename?: 'ResTemplateOptionParam';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ResTemplateSection = {
  __typename?: 'ResTemplateSection';
  description?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  /**
   * Renders the section as an input control: "select" (populated from the
   * translations list named by translationType) or "text". Absent or
   * unrecognized values render a display-only section. The section id is the
   * param key the collected value is submitted under.
   */
  inputType?: Maybe<Scalars['String']['output']>;
  /**
   * Validation pragma tokens for input sections, e.g. ["required", "numeric"].
   * Unrecognized tokens are ignored by clients (forward-compatible).
   */
  inputValidation?: Maybe<Array<Scalars['String']['output']>>;
  /** Translations list name (e.g. "vehicles") backing a select section. */
  translationType?: Maybe<Scalars['String']['output']>;
};

/** Input type for each reservation leg */
export type ResType = {
  /** Number of bags */
  bagCount?: InputMaybe<Scalars['Int']['input']>;
  /** Connection line run ID */
  connLineRun?: InputMaybe<Scalars['Int']['input']>;
  /** Dropoff location details */
  dropoff: BookLocType;
  /** Dropoff time (format: YYYY-MM-DD HH:MM:SS) */
  dropoffTime?: InputMaybe<Scalars['String']['input']>;
  /** Epic Pass validation status */
  epicPassValidated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Fare components */
  fareComponents?: InputMaybe<Array<InputMaybe<InputFieldValueType>>>;
  flags?: InputMaybe<Scalars['String']['input']>;
  /** Flight information */
  flight?: InputMaybe<BookFlightType>;
  /** Job type (e.g., "pickup", "transfer") */
  jobType?: InputMaybe<Scalars['Int']['input']>;
  /** Marketing codes for this leg */
  marketingCodes?: InputMaybe<MarketingCodesType>;
  /** Mileage for this leg */
  mileage?: InputMaybe<Scalars['Float']['input']>;
  /** Passenger details */
  passengerDetails?: InputMaybe<Array<InputMaybe<BookPassengerDetailsType>>>;
  /** Passenger types alias */
  passengerTypesAlias?: InputMaybe<Scalars['String']['input']>;
  /** Passenger counts by type */
  passengers?: InputMaybe<Array<InputMaybe<InputFieldValueType>>>;
  /** Payment information for this leg (points/frequent rider) */
  payments?: InputMaybe<BookLegPaymentsType>;
  /** Per passenger rates for pricing */
  perPassengerRates?: InputMaybe<Scalars['String']['input']>;
  /** Pickup location details */
  pickup: BookLocType;
  /** Pickup extra time */
  pickupExtra?: InputMaybe<Scalars['String']['input']>;
  /** Pickup time (format: YYYY-MM-DD HH:MM:SS) */
  pickupTime?: InputMaybe<Scalars['String']['input']>;
  /** Profile associations for this leg */
  profiles?: InputMaybe<ProfilesType>;
  /** Existing reservation ID for updates */
  resId?: InputMaybe<Scalars['String']['input']>;
  /** Internal reservation ID for updates */
  resIdInternal?: InputMaybe<Scalars['Int']['input']>;
  /** Return trip status */
  returnTripStatus?: InputMaybe<Scalars['String']['input']>;
  /** Service area ID */
  serviceArea?: InputMaybe<Scalars['Int']['input']>;
  /** Service extras */
  serviceExtras?: InputMaybe<Array<InputMaybe<InputFieldValueType>>>;
  /** Service extras alias */
  serviceExtrasAlias?: InputMaybe<Scalars['String']['input']>;
  /** Service type ID */
  serviceType?: InputMaybe<Scalars['Int']['input']>;
  /** Scheduled run ID */
  skedRun?: InputMaybe<Scalars['Int']['input']>;
  /** Special info field-value pairs */
  specialInfo?: InputMaybe<Array<InputMaybe<InputFieldValueType>>>;
  /** Special instructions for driver */
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  /** Additional special instructions */
  specialInstructions2?: InputMaybe<Scalars['String']['input']>;
  /** Stops for this leg */
  stops?: InputMaybe<Array<InputMaybe<BookStopType>>>;
  /** Travel time in minutes */
  travelTime?: InputMaybe<Scalars['Int']['input']>;
  /** User gratuity override flag */
  userGratuityOverride?: InputMaybe<Scalars['Boolean']['input']>;
  /** User gratuity percentage */
  userGratuityPercentage?: InputMaybe<Scalars['Float']['input']>;
};

export type Reservation = {
  __typename?: 'Reservation';
  auth?: Maybe<Auth>;
  bagCount: Scalars['Int']['output'];
  cancellable: Scalars['Boolean']['output'];
  cancelled: Scalars['Boolean']['output'];
  compId: Scalars['Int']['output'];
  contactInfo: ResContact;
  dropoff: Location;
  editable: Scalars['Boolean']['output'];
  epicPassId?: Maybe<Scalars['String']['output']>;
  epicPassValidated?: Maybe<Scalars['Boolean']['output']>;
  flags: Scalars['String']['output'];
  flight?: Maybe<ResFlight>;
  id: Scalars['ID']['output'];
  itineraryId?: Maybe<Scalars['String']['output']>;
  jobNumber?: Maybe<Scalars['String']['output']>;
  jobType: Scalars['Int']['output'];
  open: Scalars['Boolean']['output'];
  operation: Scalars['String']['output'];
  options?: Maybe<ResOptions>;
  other?: Maybe<ResOther>;
  passengers: Array<ResFieldValue>;
  payment?: Maybe<ResPayment>;
  pickup: Location;
  profiles?: Maybe<ResProfiles>;
  purchaseMethod?: Maybe<Scalars['String']['output']>;
  resId?: Maybe<Scalars['String']['output']>;
  resIdInternal: Scalars['Int']['output'];
  returnTripStatus: Scalars['String']['output'];
  service?: Maybe<Service>;
  serviceArea: Scalars['Int']['output'];
  serviceExtras: Array<ResFieldValue>;
  sourceType: Scalars['Int']['output'];
  stops?: Maybe<Array<ResStop>>;
  totalOriginal?: Maybe<Scalars['Float']['output']>;
  userDefined?: Maybe<Array<FieldValue>>;
  userGratuityOverride?: Maybe<Scalars['Boolean']['output']>;
  userGratuityPercentage?: Maybe<Scalars['Float']['output']>;
};

/** Card data for the rating submit. cardOnFile is derived server-side, not sent. */
export type RmrCreditCardInput = {
  /** Raw Adyen card brand (e.g. "mc", "visa"); mapped to a Bridge type code server-side. */
  cardBrand?: InputMaybe<Scalars['String']['input']>;
  encryptedCardNumber?: InputMaybe<Scalars['String']['input']>;
  encryptedExpiryMonth?: InputMaybe<Scalars['String']['input']>;
  encryptedExpiryYear?: InputMaybe<Scalars['String']['input']>;
  encryptedSecurityCode?: InputMaybe<Scalars['String']['input']>;
  expiration?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  numberLast4?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  securityCode?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

/** A gratuity preset for the tip buttons (e.g. { label: "Add 20%", percent: 20 }). */
export type RmrGratuityPercentage = {
  __typename?: 'RmrGratuityPercentage';
  label?: Maybe<Scalars['String']['output']>;
  percent?: Maybe<Scalars['Float']['output']>;
};

/** Feature flags and tip config that drive the Rate My Ride form. */
export type RmrOptions = {
  __typename?: 'RmrOptions';
  allowCreditCardEntry?: Maybe<Scalars['Boolean']['output']>;
  /** Derived from the template status: true when the form must not be submitted. */
  formLocked?: Maybe<Scalars['Boolean']['output']>;
  maxGratuityPercent?: Maybe<Scalars['Float']['output']>;
  requireCvvForCardOnFile?: Maybe<Scalars['Boolean']['output']>;
  sectionOrder?: Maybe<Array<Scalars['String']['output']>>;
  showComments?: Maybe<Scalars['Boolean']['output']>;
  showCreditCard?: Maybe<Scalars['Boolean']['output']>;
  showGratuitySection?: Maybe<Scalars['Boolean']['output']>;
  showRatings?: Maybe<Scalars['Boolean']['output']>;
};

/** Per-reservation snapshot shown on the Rate My Ride form. */
export type RmrReservation = {
  __typename?: 'RmrReservation';
  ccNumberLast4?: Maybe<Scalars['String']['output']>;
  ccToken?: Maybe<Scalars['String']['output']>;
  ccType?: Maybe<Scalars['String']['output']>;
  dropoff?: Maybe<Scalars['String']['output']>;
  fare?: Maybe<Scalars['Float']['output']>;
  gratuitySubFare?: Maybe<Scalars['Float']['output']>;
  includedGratuity?: Maybe<Scalars['Float']['output']>;
  pickup?: Maybe<Scalars['String']['output']>;
  resDate?: Maybe<Scalars['String']['output']>;
  /** Extracted from ccToken (everything before the last dash). */
  shopperReference?: Maybe<Scalars['String']['output']>;
};

export type SavePasswordPayload = MutationResponse & {
  __typename?: 'SavePasswordPayload';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SavePasswordWithPidPayload = MutationResponse & {
  __typename?: 'SavePasswordWithPidPayload';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SelectedTime = {
  __typename?: 'SelectedTime';
  connLineRun?: Maybe<Scalars['Int']['output']>;
  dropoffTime?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  pickupTime?: Maybe<Scalars['String']['output']>;
  skedRun?: Maybe<Scalars['String']['output']>;
};

/** Response from password reset request */
export type SendPasswordResetPayload = MutationResponse & {
  __typename?: 'SendPasswordResetPayload';
  /**
   * Type of error if the operation failed:
   * - BAD_USERNAME: Invalid email format or profile not found
   * - GENERAL: Other errors
   */
  errorType?: Maybe<Scalars['String']['output']>;
  /** Human-readable message about the operation result */
  message?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the password reset email was sent successfully */
  success: Scalars['Boolean']['output'];
};

export type Service = {
  __typename?: 'Service';
  bagCountMax?: Maybe<Scalars['Int']['output']>;
  checkoutPickuptimeMode?: Maybe<CheckoutPickupTimeMode>;
  defaultBaggage: Scalars['Int']['output'];
  defaultGratuityPercent?: Maybe<Scalars['Float']['output']>;
  discountDisplayMode?: Maybe<Scalars['Int']['output']>;
  fare?: Maybe<Scalars['Float']['output']>;
  fareCalculationMode?: Maybe<Scalars['String']['output']>;
  fareComponents: Array<FieldValue>;
  fareDisplay?: Maybe<Scalars['Float']['output']>;
  fareDisplayMode: Scalars['String']['output'];
  gratuityFare?: Maybe<Scalars['Float']['output']>;
  hideBaggage: Scalars['Boolean']['output'];
  hideFareMode: Scalars['String']['output'];
  hideFlightInfo: Scalars['Boolean']['output'];
  hideMaximumPassengers: Scalars['Boolean']['output'];
  hideRoundtrip?: Maybe<Scalars['Boolean']['output']>;
  hideSubfareMode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  includedGratuity: Scalars['Float']['output'];
  items: Array<Scalars['String']['output']>;
  madeByMode: Scalars['String']['output'];
  maxPassengers: Scalars['Int']['output'];
  mileage?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  originalFare?: Maybe<Scalars['Float']['output']>;
  originalIncludedGratuityPercent?: Maybe<Scalars['Float']['output']>;
  passengerTypesAlias?: Maybe<Scalars['String']['output']>;
  perPassengerRates?: Maybe<Scalars['String']['output']>;
  pickupExtras: Array<PickupExtra>;
  processorId?: Maybe<Scalars['Int']['output']>;
  raw: Scalars['String']['output'];
  roundtripPricingMode: Scalars['String']['output'];
  selectedPickupExtra?: Maybe<PickupExtra>;
  selectedTime?: Maybe<SelectedTime>;
  serviceExtrasAlias?: Maybe<Scalars['String']['output']>;
  serviceTimeNotes: Scalars['String']['output'];
  serviceType: Scalars['Int']['output'];
  showExtraStops?: Maybe<Scalars['Boolean']['output']>;
  showGratuity?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the per-time travel time should be shown in the pickup time selection */
  showTravelTime?: Maybe<Scalars['Boolean']['output']>;
  times: Array<ServiceTime>;
  totalGratuity: Scalars['Float']['output'];
  travelTime?: Maybe<Scalars['Float']['output']>;
  webSubfares: Array<FieldValue>;
};

export type ServiceArea = {
  __typename?: 'ServiceArea';
  addressType: Scalars['Int']['output'];
  country: Scalars['String']['output'];
  description: Scalars['String']['output'];
  emailAddress: Scalars['String']['output'];
  fareGroup: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  jobType: Scalars['Int']['output'];
  localWeb: Scalars['Int']['output'];
  mapInfo?: Maybe<MapPoint>;
  mappingEnabled: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  openReservationMode: Scalars['Int']['output'];
  passengerTypesAlias: Scalars['String']['output'];
  rateAlias: Scalars['String']['output'];
  residentialAddressMode: Scalars['Int']['output'];
  serviceExtrasAlias: Scalars['String']['output'];
  telephone: Scalars['String']['output'];
  telephone2: Scalars['String']['output'];
  type: Scalars['String']['output'];
  webDescription: Scalars['String']['output'];
  webOverride: Scalars['String']['output'];
  webSiteUrl: Scalars['String']['output'];
};

/** A configured service available at the site (e.g. shuttle, private car). */
export type ServiceConfigEntry = {
  __typename?: 'ServiceConfigEntry';
  /** Whether the service is currently enabled for booking. */
  enabled: Scalars['Boolean']['output'];
  /** Human-readable service name (defaults to webName; site-overridable). */
  name: Scalars['String']['output'];
  /** Numeric service-type code stored on reservations and trips. */
  serviceType: Scalars['Int']['output'];
};

export type ServiceExtra = {
  __typename?: 'ServiceExtra';
  defaultToBlank?: Maybe<Scalars['Boolean']['output']>;
  defaultValue?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  fieldName: Scalars['String']['output'];
  fixedAmount: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  maximum?: Maybe<Scalars['Int']['output']>;
  popup?: Maybe<Scalars['String']['output']>;
  raw?: Maybe<Scalars['String']['output']>;
  returnDefaultToBlank?: Maybe<Scalars['Boolean']['output']>;
  returnDefaultToFirstLeg?: Maybe<Scalars['Boolean']['output']>;
  returnDefaultValue?: Maybe<Scalars['Int']['output']>;
  surcharge?: Maybe<Scalars['Float']['output']>;
};

export type ServiceTime = {
  __typename?: 'ServiceTime';
  availableSeats?: Maybe<Scalars['Int']['output']>;
  connLineRun?: Maybe<Scalars['Int']['output']>;
  dropoffTime?: Maybe<Scalars['String']['output']>;
  fareComponents: Array<FieldValue>;
  hasAdditionalCharges: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['String']['output']>;
  offPeakCharge?: Maybe<Scalars['Float']['output']>;
  offpeak: Scalars['Boolean']['output'];
  pickupTime?: Maybe<Scalars['String']['output']>;
  raw?: Maybe<Scalars['String']['output']>;
  shortNoticeCharge?: Maybe<Scalars['Float']['output']>;
  showAvailablePassengers: Scalars['Boolean']['output'];
  skedRun?: Maybe<Scalars['Int']['output']>;
  suggested: Scalars['Boolean']['output'];
  /** Minutes from this pickup to its dropoff, when the Bridge provides it */
  travelTime?: Maybe<Scalars['Float']['output']>;
  unavailable: Scalars['Boolean']['output'];
  userGratuityPercentage?: Maybe<Scalars['Float']['output']>;
  yieldAdjustment?: Maybe<Scalars['Float']['output']>;
};

export type ServicesFieldValueInput = {
  field: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ServicesFlightInput = {
  airline?: InputMaybe<Scalars['String']['input']>;
  flightNumber?: InputMaybe<Scalars['String']['input']>;
  flightTime?: InputMaybe<Scalars['String']['input']>;
  flightType?: InputMaybe<Scalars['String']['input']>;
};

export type ServicesInput = {
  bagCount?: InputMaybe<Scalars['Int']['input']>;
  compPickupTime?: InputMaybe<Scalars['String']['input']>;
  dropoff: ServicesLocationInput;
  epicPassValidated?: InputMaybe<Scalars['Boolean']['input']>;
  fareComponents?: InputMaybe<Array<ServicesFieldValueInput>>;
  flight?: InputMaybe<ServicesFlightInput>;
  internalId?: InputMaybe<Scalars['Int']['input']>;
  mileage?: InputMaybe<Scalars['Float']['input']>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
  passengers?: InputMaybe<Array<ServicesFieldValueInput>>;
  paymentType?: InputMaybe<Scalars['String']['input']>;
  payments?: InputMaybe<ServicesPaymentInput>;
  perPassengerRates?: InputMaybe<Scalars['String']['input']>;
  pickup: ServicesLocationInput;
  pickupExtra?: InputMaybe<Scalars['String']['input']>;
  requestedPickupTime?: InputMaybe<Scalars['String']['input']>;
  reservationFlags?: InputMaybe<Scalars['String']['input']>;
  returnTripStatus?: InputMaybe<Scalars['String']['input']>;
  serviceAreaId?: InputMaybe<Scalars['Int']['input']>;
  serviceExtras?: InputMaybe<Array<ServicesFieldValueInput>>;
  serviceType?: InputMaybe<Scalars['Int']['input']>;
  stops?: InputMaybe<Array<ServicesStopInput>>;
  travelTime?: InputMaybe<Scalars['Float']['input']>;
  userGratuity?: InputMaybe<Scalars['Float']['input']>;
  userGratuityOverride?: InputMaybe<Scalars['Boolean']['input']>;
  userGratuityPercentage?: InputMaybe<Scalars['Float']['input']>;
};

export type ServicesLatLngInput = {
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
};

export type ServicesLocationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  latLng?: InputMaybe<ServicesLatLngInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  sector?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type ServicesPaymentInput = {
  amountDue?: InputMaybe<Scalars['Float']['input']>;
  items?: InputMaybe<Array<ServicesPaymentItemInput>>;
  totalPaymentAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type ServicesPaymentItemInput = {
  paymentAmount?: InputMaybe<Scalars['Float']['input']>;
  points?: InputMaybe<Scalars['Float']['input']>;
  programId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ServicesStopInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  directions?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<ServicesLocationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SetPasswordForProfilePayload = MutationResponse & {
  __typename?: 'SetPasswordForProfilePayload';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  profileId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Special information field definition */
export type SpecialInfoField = {
  __typename?: 'SpecialInfoField';
  /** Default value for the field */
  defaultValue: Scalars['String']['output'];
  /** Description or help text for the field */
  description: Scalars['String']['output'];
  /** Name of the field (used for form submission) */
  fieldName: Scalars['String']['output'];
  /** Type of the field for rendering */
  fieldType: SpecialInfoFieldType;
  /** Unique identifier for the field */
  id: Scalars['Int']['output'];
  /** Display label for the field */
  label: Scalars['String']['output'];
  /** Maximum length for text fields */
  maxLength: Scalars['Int']['output'];
  /** Minimum length for text fields */
  minLength: Scalars['Int']['output'];
  /** Raw JSON representation of the field */
  raw: Scalars['String']['output'];
  /** Whether the field is required */
  required: Scalars['Boolean']['output'];
  /** Value list for select fields (comma-separated values) */
  valueList?: Maybe<Scalars['String']['output']>;
};

/** Enum representing the type of special info field */
export enum SpecialInfoFieldType {
  /** Boolean checkbox field */
  Boolean = 'boolean',
  /** Date input field */
  Date = 'date',
  /** Field to ignore */
  Ignore = 'ignore',
  /** Numeric input field */
  Numeric = 'numeric',
  /** Select dropdown field */
  Select = 'select',
  /** Text input field */
  Text = 'text',
  /** Title text (display only) */
  Title = 'title'
}

export type StandardTemplate = {
  __typename?: 'StandardTemplate';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  specialInstr?: Maybe<Scalars['String']['output']>;
  specialInstr2?: Maybe<Scalars['String']['output']>;
};

export enum TimeFormat {
  /** 12-hour time format (e.g., 3:00 PM) */
  Twelve = 'twelve',
  /** 24-hour time format (e.g., 15:00) */
  Twentyfour = 'twentyfour'
}

export type Token = {
  __typename?: 'Token';
  defaultToken: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Response type for content query containing all available token fields */
export type TokenContent = {
  __typename?: 'TokenContent';
  beAddressDetailsLabel?: Maybe<Scalars['String']['output']>;
  beAirlineLabel?: Maybe<Scalars['String']['output']>;
  beAltphoneLabel?: Maybe<Scalars['String']['output']>;
  beApplyCouponButton?: Maybe<Scalars['String']['output']>;
  beApplyCouponLabel?: Maybe<Scalars['String']['output']>;
  beAutocompleteMoreOptionsButton?: Maybe<Scalars['String']['output']>;
  beBagsDescription?: Maybe<Scalars['String']['output']>;
  beBagsHeader?: Maybe<Scalars['String']['output']>;
  beBagsLabel?: Maybe<Scalars['String']['output']>;
  beBagsUrl?: Maybe<Scalars['String']['output']>;
  beBagsUrlLabel?: Maybe<Scalars['String']['output']>;
  beBookAnotherButton?: Maybe<Scalars['String']['output']>;
  beBookButton?: Maybe<Scalars['String']['output']>;
  beBookHeaderButton?: Maybe<Scalars['String']['output']>;
  beBookLoadingMsg?: Maybe<Scalars['String']['output']>;
  beBookReturnTripDescription?: Maybe<Scalars['String']['output']>;
  beBookReturnTripLabel?: Maybe<Scalars['String']['output']>;
  beBookingInfoSectionHeader?: Maybe<Scalars['String']['output']>;
  beCancelButton?: Maybe<Scalars['String']['output']>;
  beCancelConfirmationCancelButton?: Maybe<Scalars['String']['output']>;
  beCancelConfirmationMsg?: Maybe<Scalars['String']['output']>;
  beCancelResSuccess?: Maybe<Scalars['String']['output']>;
  beCanceledMsg?: Maybe<Scalars['String']['output']>;
  beCcAddressLabel?: Maybe<Scalars['String']['output']>;
  beCcCvvLabel?: Maybe<Scalars['String']['output']>;
  beCcExpLabel?: Maybe<Scalars['String']['output']>;
  beCcNameLabel?: Maybe<Scalars['String']['output']>;
  beCcNumberLabel?: Maybe<Scalars['String']['output']>;
  beCcPostalcodeLabel?: Maybe<Scalars['String']['output']>;
  beChangepwNewPasswordLabel?: Maybe<Scalars['String']['output']>;
  beChangepwPasswordLabel?: Maybe<Scalars['String']['output']>;
  beChangepwSubmitButton?: Maybe<Scalars['String']['output']>;
  beChangepwSuccessMsg?: Maybe<Scalars['String']['output']>;
  beCheckoutTitle?: Maybe<Scalars['String']['output']>;
  beConfirmDialogDefaultCancelButton?: Maybe<Scalars['String']['output']>;
  beConfirmDialogDefaultTitle?: Maybe<Scalars['String']['output']>;
  beConfirmationHead?: Maybe<Scalars['String']['output']>;
  beConfirmationTitle?: Maybe<Scalars['String']['output']>;
  beContactGuestCheckout?: Maybe<Scalars['String']['output']>;
  beContactPassengersHeader?: Maybe<Scalars['String']['output']>;
  beContactPassengersNameLabel?: Maybe<Scalars['String']['output']>;
  beContactPassengersText?: Maybe<Scalars['String']['output']>;
  beContactSectionTitle?: Maybe<Scalars['String']['output']>;
  beContinueButton?: Maybe<Scalars['String']['output']>;
  beContinueToCcPageButton?: Maybe<Scalars['String']['output']>;
  beConvertOpenButton?: Maybe<Scalars['String']['output']>;
  beConvertOpenCancelButton?: Maybe<Scalars['String']['output']>;
  beConvertOpenCancelConfirmation?: Maybe<Scalars['String']['output']>;
  beConvertOpenMessage?: Maybe<Scalars['String']['output']>;
  beConvertOpenSuccessMessage?: Maybe<Scalars['String']['output']>;
  beCouponAppliedMsg?: Maybe<Scalars['String']['output']>;
  beCreateNewAccountButton?: Maybe<Scalars['String']['output']>;
  beCreateNewAccountTitle?: Maybe<Scalars['String']['output']>;
  beCrossStreetLabel?: Maybe<Scalars['String']['output']>;
  beCustRequestFlightTime?: Maybe<Scalars['String']['output']>;
  beCustRequestPickupTime?: Maybe<Scalars['String']['output']>;
  beDropoffDirectionsLabel?: Maybe<Scalars['String']['output']>;
  beDropoffLocLabel?: Maybe<Scalars['String']['output']>;
  beEditBackButton?: Maybe<Scalars['String']['output']>;
  beEditLegButton?: Maybe<Scalars['String']['output']>;
  beEditOpenResButton?: Maybe<Scalars['String']['output']>;
  beEditResButton?: Maybe<Scalars['String']['output']>;
  beEditResidPrefix?: Maybe<Scalars['String']['output']>;
  beEditStopDialogConfirmButton?: Maybe<Scalars['String']['output']>;
  beEditStopDialogConfirmMessage?: Maybe<Scalars['String']['output']>;
  beEmailLabel?: Maybe<Scalars['String']['output']>;
  beEmailProfileCheckLoginButton?: Maybe<Scalars['String']['output']>;
  beEmailProfileCheckMsg?: Maybe<Scalars['String']['output']>;
  beEpicPassAppliedMsg?: Maybe<Scalars['String']['output']>;
  beEpicPassIdLabel?: Maybe<Scalars['String']['output']>;
  beEpicPassSubmitBtn?: Maybe<Scalars['String']['output']>;
  beErrAddressDetails?: Maybe<Scalars['String']['output']>;
  beErrAirline?: Maybe<Scalars['String']['output']>;
  beErrAltphone?: Maybe<Scalars['String']['output']>;
  beErrAltphoneFormat?: Maybe<Scalars['String']['output']>;
  beErrBadCoupon?: Maybe<Scalars['String']['output']>;
  beErrBagCountMax?: Maybe<Scalars['String']['output']>;
  beErrCantVerify?: Maybe<Scalars['String']['output']>;
  beErrCcAddress?: Maybe<Scalars['String']['output']>;
  beErrCcCvv?: Maybe<Scalars['String']['output']>;
  beErrCcExp?: Maybe<Scalars['String']['output']>;
  beErrCcName?: Maybe<Scalars['String']['output']>;
  beErrCcNumber?: Maybe<Scalars['String']['output']>;
  beErrCcNumberInvalid?: Maybe<Scalars['String']['output']>;
  beErrCcNumberType?: Maybe<Scalars['String']['output']>;
  beErrCcPostalcode?: Maybe<Scalars['String']['output']>;
  beErrEmail?: Maybe<Scalars['String']['output']>;
  beErrEmailFormat?: Maybe<Scalars['String']['output']>;
  beErrEpicLogin?: Maybe<Scalars['String']['output']>;
  beErrFaxNumberFormat?: Maybe<Scalars['String']['output']>;
  beErrFieldRequired?: Maybe<Scalars['String']['output']>;
  beErrFlightCityArrivals?: Maybe<Scalars['String']['output']>;
  beErrFlightCityDepartures?: Maybe<Scalars['String']['output']>;
  beErrFlightNumArrivals?: Maybe<Scalars['String']['output']>;
  beErrFlightNumDepartures?: Maybe<Scalars['String']['output']>;
  beErrGroupLogin?: Maybe<Scalars['String']['output']>;
  beErrGroupPasswordLogin?: Maybe<Scalars['String']['output']>;
  beErrLinkedGroups?: Maybe<Scalars['String']['output']>;
  beErrLocTooGeneral?: Maybe<Scalars['String']['output']>;
  beErrLookupEmailFormat?: Maybe<Scalars['String']['output']>;
  beErrMarketingCode?: Maybe<Scalars['String']['output']>;
  beErrMarketingCode2?: Maybe<Scalars['String']['output']>;
  beErrMarketingCode3?: Maybe<Scalars['String']['output']>;
  beErrMaxPassengers?: Maybe<Scalars['String']['output']>;
  beErrName?: Maybe<Scalars['String']['output']>;
  beErrNoFareKey?: Maybe<Scalars['String']['output']>;
  beErrNoLocsFound?: Maybe<Scalars['String']['output']>;
  beErrNoLocsFoundFixed?: Maybe<Scalars['String']['output']>;
  beErrNoPickuptimes?: Maybe<Scalars['String']['output']>;
  beErrNoService?: Maybe<Scalars['String']['output']>;
  beErrNoServiceTitle?: Maybe<Scalars['String']['output']>;
  beErrPassengers?: Maybe<Scalars['String']['output']>;
  beErrPasswordMinLength?: Maybe<Scalars['String']['output']>;
  beErrPasswordUpdate?: Maybe<Scalars['String']['output']>;
  beErrPhone?: Maybe<Scalars['String']['output']>;
  beErrPhoneFormat?: Maybe<Scalars['String']['output']>;
  beErrPickupTimeArrival?: Maybe<Scalars['String']['output']>;
  beErrPickupTimeDeparture?: Maybe<Scalars['String']['output']>;
  beErrProfileCcAdd?: Maybe<Scalars['String']['output']>;
  beErrProfileCcRemove?: Maybe<Scalars['String']['output']>;
  beErrProfileLocationsAdd?: Maybe<Scalars['String']['output']>;
  beErrProfileLocationsDelete?: Maybe<Scalars['String']['output']>;
  beErrProfileLocationsUpdate?: Maybe<Scalars['String']['output']>;
  beErrProfileUpdate?: Maybe<Scalars['String']['output']>;
  beErrPudPersonCcRemove?: Maybe<Scalars['String']['output']>;
  beErrResNotCanceled?: Maybe<Scalars['String']['output']>;
  beErrResNotConverted?: Maybe<Scalars['String']['output']>;
  beErrResetpwGeneral?: Maybe<Scalars['String']['output']>;
  beErrSessionExpired?: Maybe<Scalars['String']['output']>;
  beErrSpecialInfoMin?: Maybe<Scalars['String']['output']>;
  beErrSpecialInstr?: Maybe<Scalars['String']['output']>;
  beErrSpecialInstr2?: Maybe<Scalars['String']['output']>;
  beErrStopsComments?: Maybe<Scalars['String']['output']>;
  beErrStopsName?: Maybe<Scalars['String']['output']>;
  beErrStopsReprice?: Maybe<Scalars['String']['output']>;
  beErrSystemError?: Maybe<Scalars['String']['output']>;
  beErrTerms?: Maybe<Scalars['String']['output']>;
  beErrUserLogin?: Maybe<Scalars['String']['output']>;
  beErrUsernameBad?: Maybe<Scalars['String']['output']>;
  beExternalCcMessage?: Maybe<Scalars['String']['output']>;
  beExtraStopLabel?: Maybe<Scalars['String']['output']>;
  beFaxNumberLabel?: Maybe<Scalars['String']['output']>;
  beFirstLegHeader?: Maybe<Scalars['String']['output']>;
  beFlightCityArrivalsLabel?: Maybe<Scalars['String']['output']>;
  beFlightCityDeparturesLabel?: Maybe<Scalars['String']['output']>;
  beFlightDateArrLabel?: Maybe<Scalars['String']['output']>;
  beFlightDateDepLabel?: Maybe<Scalars['String']['output']>;
  beFlightDateLabel?: Maybe<Scalars['String']['output']>;
  beFlightNumberLabel?: Maybe<Scalars['String']['output']>;
  beFlightSectionExtrasSubtitle?: Maybe<Scalars['String']['output']>;
  beFlightSectionFlightSubtitle?: Maybe<Scalars['String']['output']>;
  beFlightSectionTitle?: Maybe<Scalars['String']['output']>;
  beFlightTimeArrLabel?: Maybe<Scalars['String']['output']>;
  beFlightTimeDepLabel?: Maybe<Scalars['String']['output']>;
  beFlightTimeLabel?: Maybe<Scalars['String']['output']>;
  beFlightTypeInternationalLabel?: Maybe<Scalars['String']['output']>;
  beForgotPwButton?: Maybe<Scalars['String']['output']>;
  beFrpBookAnotherButton?: Maybe<Scalars['String']['output']>;
  beFrpBookButton?: Maybe<Scalars['String']['output']>;
  beFrpBookLoadingMsg?: Maybe<Scalars['String']['output']>;
  beFrpButton?: Maybe<Scalars['String']['output']>;
  beFrpConfirmationHead?: Maybe<Scalars['String']['output']>;
  beFrpConfirmationTitle?: Maybe<Scalars['String']['output']>;
  beFrpFreeRides?: Maybe<Scalars['String']['output']>;
  beFrpGoodThru?: Maybe<Scalars['String']['output']>;
  beFrpNoPrograms?: Maybe<Scalars['String']['output']>;
  beFrpQuantityLabel?: Maybe<Scalars['String']['output']>;
  beFrpStartDateLabel?: Maybe<Scalars['String']['output']>;
  beFrpSubmitBtn?: Maybe<Scalars['String']['output']>;
  beGratuityIncludedMsg?: Maybe<Scalars['String']['output']>;
  beGratuityRtGratuityIsLabel?: Maybe<Scalars['String']['output']>;
  beGratuitySectionGrpSvcContent?: Maybe<Scalars['String']['output']>;
  beGratuitySectionTitle?: Maybe<Scalars['String']['output']>;
  beGratuityZeroDefaultLabel?: Maybe<Scalars['String']['output']>;
  beGroupLoginCodeLabel?: Maybe<Scalars['String']['output']>;
  beGroupLoginPrompt?: Maybe<Scalars['String']['output']>;
  beGroupLoginSubmitBtn?: Maybe<Scalars['String']['output']>;
  beGroupLoginSubmitButton?: Maybe<Scalars['String']['output']>;
  beGroupLogoutLabel?: Maybe<Scalars['String']['output']>;
  beGroupPasswordLabel?: Maybe<Scalars['String']['output']>;
  beGroupPwBackButton?: Maybe<Scalars['String']['output']>;
  beHeaderProfileButton?: Maybe<Scalars['String']['output']>;
  beLocAmenIconH?: Maybe<Scalars['String']['output']>;
  beLocAmenIconNP?: Maybe<Scalars['String']['output']>;
  beLocAmenIconP?: Maybe<Scalars['String']['output']>;
  beLocAmenIconR?: Maybe<Scalars['String']['output']>;
  beLocAmenIconV?: Maybe<Scalars['String']['output']>;
  beLocationDialogCommonCatsHeader?: Maybe<Scalars['String']['output']>;
  beLocationDialogTopLocHeader?: Maybe<Scalars['String']['output']>;
  beLocationSectionTitle?: Maybe<Scalars['String']['output']>;
  beLocationStringLabel?: Maybe<Scalars['String']['output']>;
  beLocationtypeNamePuds?: Maybe<Scalars['String']['output']>;
  beLoginSubmitButton?: Maybe<Scalars['String']['output']>;
  beLoginTitle?: Maybe<Scalars['String']['output']>;
  beLogoutButton?: Maybe<Scalars['String']['output']>;
  beLogoutConfirmationButton?: Maybe<Scalars['String']['output']>;
  beLogoutConfirmationMsg?: Maybe<Scalars['String']['output']>;
  beLogoutConfirmationTitle?: Maybe<Scalars['String']['output']>;
  beMadeByLabel?: Maybe<Scalars['String']['output']>;
  beMakeOneWayResButton?: Maybe<Scalars['String']['output']>;
  beManageTripsButton?: Maybe<Scalars['String']['output']>;
  beMapPopupLinkLabel?: Maybe<Scalars['String']['output']>;
  beMarketingCode2Label?: Maybe<Scalars['String']['output']>;
  beMarketingCode3Label?: Maybe<Scalars['String']['output']>;
  beMarketingCodeLabel?: Maybe<Scalars['String']['output']>;
  beNameLabel?: Maybe<Scalars['String']['output']>;
  beNearbyLocsAway?: Maybe<Scalars['String']['output']>;
  beNearbyLocsFeet?: Maybe<Scalars['String']['output']>;
  beNearbyLocsHeaderMsgLocAvailable?: Maybe<Scalars['String']['output']>;
  beNearbyLocsHeaderMsgLocNotAvailable?: Maybe<Scalars['String']['output']>;
  beNearbyLocsHeaderPrefix?: Maybe<Scalars['String']['output']>;
  beNearbyLocsMiles?: Maybe<Scalars['String']['output']>;
  beNearbyLocsSectHeaderNearbyLocs?: Maybe<Scalars['String']['output']>;
  beNearbyLocsSectHeaderReqLoc?: Maybe<Scalars['String']['output']>;
  beNearbyLocsSectSubheadNearbyLocs?: Maybe<Scalars['String']['output']>;
  beNearbyLocsSectSubheadReqLoc?: Maybe<Scalars['String']['output']>;
  beNewProfileBackButton?: Maybe<Scalars['String']['output']>;
  beNewProfileSubmitButton?: Maybe<Scalars['String']['output']>;
  beNewProfileTitle?: Maybe<Scalars['String']['output']>;
  beNewTotalLabel?: Maybe<Scalars['String']['output']>;
  bePaginationOf?: Maybe<Scalars['String']['output']>;
  bePassengersHeader?: Maybe<Scalars['String']['output']>;
  bePasswordAriaHide?: Maybe<Scalars['String']['output']>;
  bePasswordAriaShow?: Maybe<Scalars['String']['output']>;
  bePasswordLabel?: Maybe<Scalars['String']['output']>;
  bePaymentCashPayment?: Maybe<Scalars['String']['output']>;
  bePaymentCashSectionTitle?: Maybe<Scalars['String']['output']>;
  bePaymentCcDialogSaveButton?: Maybe<Scalars['String']['output']>;
  bePaymentCcDialogTitle?: Maybe<Scalars['String']['output']>;
  bePaymentCcDifferentCardLabel?: Maybe<Scalars['String']['output']>;
  bePaymentCcSectionTitle?: Maybe<Scalars['String']['output']>;
  bePaymentCcTokenizedEndingIn?: Maybe<Scalars['String']['output']>;
  bePaymentCcTokenizedExpires?: Maybe<Scalars['String']['output']>;
  bePaymentDbSectionTitle?: Maybe<Scalars['String']['output']>;
  bePaymentDirectbillPayment?: Maybe<Scalars['String']['output']>;
  bePaymentPaidWithPoints?: Maybe<Scalars['String']['output']>;
  bePaymentRemoveButton?: Maybe<Scalars['String']['output']>;
  bePaymentSectionTitle?: Maybe<Scalars['String']['output']>;
  bePaymentnotesCc?: Maybe<Scalars['String']['output']>;
  bePaymentnotesCc2?: Maybe<Scalars['String']['output']>;
  bePaymentnotesDb?: Maybe<Scalars['String']['output']>;
  bePaymentnotesFr?: Maybe<Scalars['String']['output']>;
  bePhoneLabel?: Maybe<Scalars['String']['output']>;
  bePickupDateLabel?: Maybe<Scalars['String']['output']>;
  bePickupDirectionsLabel?: Maybe<Scalars['String']['output']>;
  bePickupLocLabel?: Maybe<Scalars['String']['output']>;
  bePickupTimeArrive?: Maybe<Scalars['String']['output']>;
  bePickupTimeAvailableSeats?: Maybe<Scalars['String']['output']>;
  bePickupTimeFilterLabel?: Maybe<Scalars['String']['output']>;
  bePickupTimeFlightHours?: Maybe<Scalars['String']['output']>;
  bePickupTimeFlightMinutes?: Maybe<Scalars['String']['output']>;
  bePickupTimeFlightPreArr?: Maybe<Scalars['String']['output']>;
  bePickupTimeFlightPreDep?: Maybe<Scalars['String']['output']>;
  bePickupTimeFlightSufArr?: Maybe<Scalars['String']['output']>;
  bePickupTimeFlightSufDep?: Maybe<Scalars['String']['output']>;
  bePickupTimeHeaderArr?: Maybe<Scalars['String']['output']>;
  bePickupTimeHeaderDep?: Maybe<Scalars['String']['output']>;
  bePickupTimeHeaderPtp?: Maybe<Scalars['String']['output']>;
  bePickupTimeLabel?: Maybe<Scalars['String']['output']>;
  bePickupTimeOffPeak?: Maybe<Scalars['String']['output']>;
  bePickupTimeShortNotice?: Maybe<Scalars['String']['output']>;
  bePickupTimeShowAdtlTimes?: Maybe<Scalars['String']['output']>;
  bePickupTimeShowButton?: Maybe<Scalars['String']['output']>;
  bePickupTimeTravelTime?: Maybe<Scalars['String']['output']>;
  bePickupTimeUserSelectDiffAfter?: Maybe<Scalars['String']['output']>;
  bePickupTimeUserSelectDiffBefore?: Maybe<Scalars['String']['output']>;
  bePickupTimeUserSelectDiffSame?: Maybe<Scalars['String']['output']>;
  bePickuptimeSectionTitle?: Maybe<Scalars['String']['output']>;
  bePointsDontUsePtsLabel?: Maybe<Scalars['String']['output']>;
  bePointsMinPointsLabel?: Maybe<Scalars['String']['output']>;
  bePointsNewTotalLabel?: Maybe<Scalars['String']['output']>;
  bePointsNumPointsLabel?: Maybe<Scalars['String']['output']>;
  bePointsPointsAvailSfx?: Maybe<Scalars['String']['output']>;
  bePointsSectionTitle?: Maybe<Scalars['String']['output']>;
  beProfileAccountButton?: Maybe<Scalars['String']['output']>;
  beProfileAltphoneLabel?: Maybe<Scalars['String']['output']>;
  beProfileCcAddSubmitButton?: Maybe<Scalars['String']['output']>;
  beProfileCcAddSuccessMsg?: Maybe<Scalars['String']['output']>;
  beProfileCcAddTitle?: Maybe<Scalars['String']['output']>;
  beProfileCcRemoveDialogMessage?: Maybe<Scalars['String']['output']>;
  beProfileCcRemoveDialogSubmitButton?: Maybe<Scalars['String']['output']>;
  beProfileCcRemoveDialogTitle?: Maybe<Scalars['String']['output']>;
  beProfileCcRemoveSuccessMsg?: Maybe<Scalars['String']['output']>;
  beProfileCcSavedCardsTitle?: Maybe<Scalars['String']['output']>;
  beProfileContactSectionTitle?: Maybe<Scalars['String']['output']>;
  beProfileContactTab?: Maybe<Scalars['String']['output']>;
  beProfileEmailLabel?: Maybe<Scalars['String']['output']>;
  beProfileHomeTitle?: Maybe<Scalars['String']['output']>;
  beProfileLgLabelClientid?: Maybe<Scalars['String']['output']>;
  beProfileLgLabelData1?: Maybe<Scalars['String']['output']>;
  beProfileLgLabelData2?: Maybe<Scalars['String']['output']>;
  beProfileLgLabelGroupid?: Maybe<Scalars['String']['output']>;
  beProfileLgLabelWebid?: Maybe<Scalars['String']['output']>;
  beProfileLinkedGroupsCancelButton?: Maybe<Scalars['String']['output']>;
  beProfileLinkedGroupsChangeButton?: Maybe<Scalars['String']['output']>;
  beProfileLinkedGroupsSubmitButton?: Maybe<Scalars['String']['output']>;
  beProfileLinkedGroupsSuccessMsg?: Maybe<Scalars['String']['output']>;
  beProfileLinkedGroupsTab?: Maybe<Scalars['String']['output']>;
  beProfileLinkedGroupsTitle?: Maybe<Scalars['String']['output']>;
  beProfileLinkedGroupsValidatedLabel?: Maybe<Scalars['String']['output']>;
  beProfileLocationTypeLabel?: Maybe<Scalars['String']['output']>;
  beProfileLocationsAddButton?: Maybe<Scalars['String']['output']>;
  beProfileLocationsAddSuccess?: Maybe<Scalars['String']['output']>;
  beProfileLocationsDeleteSuccess?: Maybe<Scalars['String']['output']>;
  beProfileLocationsEditButton?: Maybe<Scalars['String']['output']>;
  beProfileLocationsFieldLabel?: Maybe<Scalars['String']['output']>;
  beProfileLocationsNewLocSubmitButton?: Maybe<Scalars['String']['output']>;
  beProfileLocationsNewLocTitle?: Maybe<Scalars['String']['output']>;
  beProfileLocationsNewUpdateLocCancelButton?: Maybe<Scalars['String']['output']>;
  beProfileLocationsRemoveButton?: Maybe<Scalars['String']['output']>;
  beProfileLocationsRemoveDialogCancelButton?: Maybe<Scalars['String']['output']>;
  beProfileLocationsRemoveDialogConfirmButton?: Maybe<Scalars['String']['output']>;
  beProfileLocationsRemoveDialogConfirmMessage?: Maybe<Scalars['String']['output']>;
  beProfileLocationsRemoveDialogTitle?: Maybe<Scalars['String']['output']>;
  beProfileLocationsTab?: Maybe<Scalars['String']['output']>;
  beProfileLocationsTitle?: Maybe<Scalars['String']['output']>;
  beProfileLocationsUpdateLocSubmitButton?: Maybe<Scalars['String']['output']>;
  beProfileLocationsUpdateLocTitle?: Maybe<Scalars['String']['output']>;
  beProfileLocationsUpdateSuccess?: Maybe<Scalars['String']['output']>;
  beProfileNameLabel?: Maybe<Scalars['String']['output']>;
  beProfilePasswordLabel?: Maybe<Scalars['String']['output']>;
  beProfilePasswordTab?: Maybe<Scalars['String']['output']>;
  beProfilePasswordTitle?: Maybe<Scalars['String']['output']>;
  beProfilePaymentTab?: Maybe<Scalars['String']['output']>;
  beProfilePhoneLabel?: Maybe<Scalars['String']['output']>;
  beProfilePointsTab?: Maybe<Scalars['String']['output']>;
  beProfilePointsTableExpiresPrefix?: Maybe<Scalars['String']['output']>;
  beProfilePointsTableResidPrefix?: Maybe<Scalars['String']['output']>;
  beProfilePointsTitle?: Maybe<Scalars['String']['output']>;
  beProfilePointsTransactionsTitle?: Maybe<Scalars['String']['output']>;
  beProfileResNoResMessage?: Maybe<Scalars['String']['output']>;
  beProfileResNoResMessageTitle?: Maybe<Scalars['String']['output']>;
  beProfileResOpenTab?: Maybe<Scalars['String']['output']>;
  beProfileResPastTab?: Maybe<Scalars['String']['output']>;
  beProfileResUpcomingTab?: Maybe<Scalars['String']['output']>;
  beProfileResViewDetailsButton?: Maybe<Scalars['String']['output']>;
  beProfileResViewDetailsOpenButton?: Maybe<Scalars['String']['output']>;
  beProfileReservationsTab?: Maybe<Scalars['String']['output']>;
  beProfileUpdateSubmitButton?: Maybe<Scalars['String']['output']>;
  beProfileUpdateSuccessMsg?: Maybe<Scalars['String']['output']>;
  beProfileUsernameLabel?: Maybe<Scalars['String']['output']>;
  bePudPersonAltphoneLabel?: Maybe<Scalars['String']['output']>;
  bePudPersonCcRemoveDialogMessage?: Maybe<Scalars['String']['output']>;
  bePudPersonCcRemoveDialogSubmitButton?: Maybe<Scalars['String']['output']>;
  bePudPersonCcRemoveDialogTitle?: Maybe<Scalars['String']['output']>;
  bePudPersonCcRemoveSuccessMsg?: Maybe<Scalars['String']['output']>;
  bePudPersonCcSectionTitle?: Maybe<Scalars['String']['output']>;
  bePudPersonContactSectionTitle?: Maybe<Scalars['String']['output']>;
  bePudPersonEmailLabel?: Maybe<Scalars['String']['output']>;
  bePudPersonFaxLabel?: Maybe<Scalars['String']['output']>;
  bePudPersonLabel?: Maybe<Scalars['String']['output']>;
  bePudPersonNameLabel?: Maybe<Scalars['String']['output']>;
  bePudPersonPhoneLabel?: Maybe<Scalars['String']['output']>;
  beReferralsHead?: Maybe<Scalars['String']['output']>;
  beRemoveCouponLabel?: Maybe<Scalars['String']['output']>;
  beRemoveLegButton?: Maybe<Scalars['String']['output']>;
  beRequiredPlaceholder?: Maybe<Scalars['String']['output']>;
  beResetpwContent?: Maybe<Scalars['String']['output']>;
  beResetpwNewPasswordLabel?: Maybe<Scalars['String']['output']>;
  beResetpwSubmitButton?: Maybe<Scalars['String']['output']>;
  beResetpwSuccessMsg?: Maybe<Scalars['String']['output']>;
  beResetpwTitle?: Maybe<Scalars['String']['output']>;
  beReslookupHead?: Maybe<Scalars['String']['output']>;
  beReslookupResnumLabel?: Maybe<Scalars['String']['output']>;
  beReslookupValidationTypeLabel?: Maybe<Scalars['String']['output']>;
  beReslookupValidationValueLabel?: Maybe<Scalars['String']['output']>;
  beRessummaryAmountPaidLabel?: Maybe<Scalars['String']['output']>;
  beRessummaryBackButton?: Maybe<Scalars['String']['output']>;
  beRessummaryCancelledLabel?: Maybe<Scalars['String']['output']>;
  beRessummaryCashPayment?: Maybe<Scalars['String']['output']>;
  beRessummaryDirectbillPayment?: Maybe<Scalars['String']['output']>;
  beRessummaryFlightSectionTitle?: Maybe<Scalars['String']['output']>;
  beRessummaryHead?: Maybe<Scalars['String']['output']>;
  beRessummaryPickupAtLabel?: Maybe<Scalars['String']['output']>;
  beRessummaryPointsUsedLabel?: Maybe<Scalars['String']['output']>;
  beRessummaryTotalLabel?: Maybe<Scalars['String']['output']>;
  beReturnTripHeader?: Maybe<Scalars['String']['output']>;
  beSelectNoOptions?: Maybe<Scalars['String']['output']>;
  beSendResetpwBackButton?: Maybe<Scalars['String']['output']>;
  beSendResetpwContent?: Maybe<Scalars['String']['output']>;
  beSendResetpwSubmitButton?: Maybe<Scalars['String']['output']>;
  beSendResetpwSuccessMsg?: Maybe<Scalars['String']['output']>;
  beSendResetpwTitle?: Maybe<Scalars['String']['output']>;
  beServiceExtraEachLabel?: Maybe<Scalars['String']['output']>;
  beServiceExtrasHeader?: Maybe<Scalars['String']['output']>;
  beServicePsgrsMaximum?: Maybe<Scalars['String']['output']>;
  beServiceSelectButton?: Maybe<Scalars['String']['output']>;
  beServiceStartingAt?: Maybe<Scalars['String']['output']>;
  beSidebarHeader?: Maybe<Scalars['String']['output']>;
  beSidebarPointsUsedLabel?: Maybe<Scalars['String']['output']>;
  beSidebarResidLabel?: Maybe<Scalars['String']['output']>;
  beSidebarTotalLabel?: Maybe<Scalars['String']['output']>;
  beSpecialInstr2Label?: Maybe<Scalars['String']['output']>;
  beSpecialInstrLabel?: Maybe<Scalars['String']['output']>;
  beSrvextraSelectBlank?: Maybe<Scalars['String']['output']>;
  beStopsAddButton?: Maybe<Scalars['String']['output']>;
  beStopsCommentsLabel?: Maybe<Scalars['String']['output']>;
  beStopsDirectionsLabel?: Maybe<Scalars['String']['output']>;
  beStopsHeader?: Maybe<Scalars['String']['output']>;
  beStopsNameLabel?: Maybe<Scalars['String']['output']>;
  beStopsNotAllowed?: Maybe<Scalars['String']['output']>;
  beStopsRemoveButton?: Maybe<Scalars['String']['output']>;
  beStopsSectionTitle?: Maybe<Scalars['String']['output']>;
  beStopsStopPrefix?: Maybe<Scalars['String']['output']>;
  beSuggestcreateConfirm?: Maybe<Scalars['String']['output']>;
  beSuggestcreateContent?: Maybe<Scalars['String']['output']>;
  beSuggestcreateSaveButton?: Maybe<Scalars['String']['output']>;
  beSuggestcreateTitle?: Maybe<Scalars['String']['output']>;
  beSuggestloginContent?: Maybe<Scalars['String']['output']>;
  beSuggestloginLoginButton?: Maybe<Scalars['String']['output']>;
  beSuggestloginTitle?: Maybe<Scalars['String']['output']>;
  beTermsConditionsLabel?: Maybe<Scalars['String']['output']>;
  beTermsConditionsUrl?: Maybe<Scalars['String']['output']>;
  beTermsConditionsUrlLabel?: Maybe<Scalars['String']['output']>;
  beUsernameLabel?: Maybe<Scalars['String']['output']>;
  beVarianceNegativeLabel?: Maybe<Scalars['String']['output']>;
  beVariancePositiveLabel?: Maybe<Scalars['String']['output']>;
  beVarianceZero?: Maybe<Scalars['String']['output']>;
  beWebSubfareACaption?: Maybe<Scalars['String']['output']>;
  beWebSubfareBCaption?: Maybe<Scalars['String']['output']>;
  beWebSubfareCCaption?: Maybe<Scalars['String']['output']>;
  beWebSubfareDCaption?: Maybe<Scalars['String']['output']>;
  beWebSubfareECaption?: Maybe<Scalars['String']['output']>;
  beWebSubfareSummary?: Maybe<Scalars['String']['output']>;
  beWebSubfaresContent?: Maybe<Scalars['String']['output']>;
  beWebSubfaresHeader?: Maybe<Scalars['String']['output']>;
  ccVLabel?: Maybe<Scalars['String']['output']>;
  charterName?: Maybe<Scalars['String']['output']>;
  commentsLabel?: Maybe<Scalars['String']['output']>;
  couponName?: Maybe<Scalars['String']['output']>;
  creditCardCancelLabel?: Maybe<Scalars['String']['output']>;
  creditCardChangeLabel?: Maybe<Scalars['String']['output']>;
  creditCardExpLabel?: Maybe<Scalars['String']['output']>;
  creditCardNameLabel?: Maybe<Scalars['String']['output']>;
  creditCardNumLabel?: Maybe<Scalars['String']['output']>;
  creditCardSecCodeLabel?: Maybe<Scalars['String']['output']>;
  creditCardZipLabel?: Maybe<Scalars['String']['output']>;
  customTip?: Maybe<Scalars['String']['output']>;
  customTipPlaceholder?: Maybe<Scalars['String']['output']>;
  daContinueButton?: Maybe<Scalars['String']['output']>;
  daDriverDetailEmpty?: Maybe<Scalars['String']['output']>;
  daDriverShiftDetailEmpty?: Maybe<Scalars['String']['output']>;
  daErrFieldRequired?: Maybe<Scalars['String']['output']>;
  daErrSessionExpired?: Maybe<Scalars['String']['output']>;
  daErrSystemError?: Maybe<Scalars['String']['output']>;
  daErrorDialogOkBtn?: Maybe<Scalars['String']['output']>;
  daExternalAppClose?: Maybe<Scalars['String']['output']>;
  daExternalAppTitle?: Maybe<Scalars['String']['output']>;
  daGridClearAllFilters?: Maybe<Scalars['String']['output']>;
  daGridCurrentPage?: Maybe<Scalars['String']['output']>;
  daGridDriverShiftsBreakLabel?: Maybe<Scalars['String']['output']>;
  daGridDriverShiftsConfirmed?: Maybe<Scalars['String']['output']>;
  daGridDriverShiftsDriverFallback?: Maybe<Scalars['String']['output']>;
  daGridDriverShiftsIdentifierKicker?: Maybe<Scalars['String']['output']>;
  daGridDriverShiftsNotConfirmed?: Maybe<Scalars['String']['output']>;
  daGridDriverShiftsOdometerEndLabel?: Maybe<Scalars['String']['output']>;
  daGridDriverShiftsOdometerStartLabel?: Maybe<Scalars['String']['output']>;
  daGridDriversIdentifierKicker?: Maybe<Scalars['String']['output']>;
  daGridFilterColumns?: Maybe<Scalars['String']['output']>;
  daGridFilterColumnsActive?: Maybe<Scalars['String']['output']>;
  daGridFilteredCount?: Maybe<Scalars['String']['output']>;
  daGridLoadError?: Maybe<Scalars['String']['output']>;
  daGridNextPage?: Maybe<Scalars['String']['output']>;
  daGridNoFilterResults?: Maybe<Scalars['String']['output']>;
  daGridPage?: Maybe<Scalars['String']['output']>;
  daGridPageRange?: Maybe<Scalars['String']['output']>;
  daGridPaginationNav?: Maybe<Scalars['String']['output']>;
  daGridPrevPage?: Maybe<Scalars['String']['output']>;
  daGridQuickFilterDefault?: Maybe<Scalars['String']['output']>;
  daGridQuickfactActual?: Maybe<Scalars['String']['output']>;
  daGridQuickfactActualend?: Maybe<Scalars['String']['output']>;
  daGridQuickfactActualstart?: Maybe<Scalars['String']['output']>;
  daGridQuickfactBagcount?: Maybe<Scalars['String']['output']>;
  daGridQuickfactColor?: Maybe<Scalars['String']['output']>;
  daGridQuickfactDistance?: Maybe<Scalars['String']['output']>;
  daGridQuickfactDriver?: Maybe<Scalars['String']['output']>;
  daGridQuickfactEmail?: Maybe<Scalars['String']['output']>;
  daGridQuickfactEmployeeid?: Maybe<Scalars['String']['output']>;
  daGridQuickfactExtras?: Maybe<Scalars['String']['output']>;
  daGridQuickfactExtrastops?: Maybe<Scalars['String']['output']>;
  daGridQuickfactFare?: Maybe<Scalars['String']['output']>;
  daGridQuickfactFlight?: Maybe<Scalars['String']['output']>;
  daGridQuickfactFueltype?: Maybe<Scalars['String']['output']>;
  daGridQuickfactLayout?: Maybe<Scalars['String']['output']>;
  daGridQuickfactMakemodel?: Maybe<Scalars['String']['output']>;
  daGridQuickfactMaxpass?: Maybe<Scalars['String']['output']>;
  daGridQuickfactPax?: Maybe<Scalars['String']['output']>;
  daGridQuickfactReporttime?: Maybe<Scalars['String']['output']>;
  daGridQuickfactStartlocation?: Maybe<Scalars['String']['output']>;
  daGridQuickfactStatus?: Maybe<Scalars['String']['output']>;
  daGridQuickfactStops?: Maybe<Scalars['String']['output']>;
  daGridQuickfactTelephone?: Maybe<Scalars['String']['output']>;
  daGridQuickfactTelephone2?: Maybe<Scalars['String']['output']>;
  daGridQuickfactVehicle?: Maybe<Scalars['String']['output']>;
  daGridQuickfactVehicletype?: Maybe<Scalars['String']['output']>;
  daGridRefreshLabel?: Maybe<Scalars['String']['output']>;
  daGridRefreshingLabel?: Maybe<Scalars['String']['output']>;
  daGridReservationsIdentifierKicker?: Maybe<Scalars['String']['output']>;
  daGridRouteDropoffLabel?: Maybe<Scalars['String']['output']>;
  daGridRoutePickupLabel?: Maybe<Scalars['String']['output']>;
  daGridStaleAt?: Maybe<Scalars['String']['output']>;
  daGridTripsIdentifierKicker?: Maybe<Scalars['String']['output']>;
  daGridUpdatedAt?: Maybe<Scalars['String']['output']>;
  daGridVehiclesIdentifierKicker?: Maybe<Scalars['String']['output']>;
  daHotkeyErrGeneric?: Maybe<Scalars['String']['output']>;
  daHotkeyErrInvalidProtocol?: Maybe<Scalars['String']['output']>;
  daHotkeyErrNoUrl?: Maybe<Scalars['String']['output']>;
  daLoginSubmitButton?: Maybe<Scalars['String']['output']>;
  daLoginTitle?: Maybe<Scalars['String']['output']>;
  daMessagesComposerPlaceholder?: Maybe<Scalars['String']['output']>;
  daMessagesComposerSendError?: Maybe<Scalars['String']['output']>;
  daMessagesEmpty?: Maybe<Scalars['String']['output']>;
  daMessagesLoadOlder?: Maybe<Scalars['String']['output']>;
  daMessagesOlderCount?: Maybe<Scalars['String']['output']>;
  daMsgMarkRead?: Maybe<Scalars['String']['output']>;
  daPasswordLabel?: Maybe<Scalars['String']['output']>;
  daRefreshErrorFallback?: Maybe<Scalars['String']['output']>;
  daRequiredPlaceholder?: Maybe<Scalars['String']['output']>;
  daResCancelledBadge?: Maybe<Scalars['String']['output']>;
  daResDetailEmpty?: Maybe<Scalars['String']['output']>;
  daResFlightArrivesLabel?: Maybe<Scalars['String']['output']>;
  daResFlightCityLabel?: Maybe<Scalars['String']['output']>;
  daResFlightDepartsLabel?: Maybe<Scalars['String']['output']>;
  daResFlightNumberLabel?: Maybe<Scalars['String']['output']>;
  daResFlightTerminalLabel?: Maybe<Scalars['String']['output']>;
  daResFlightTimeLabel?: Maybe<Scalars['String']['output']>;
  daResFlightTypeDomestic?: Maybe<Scalars['String']['output']>;
  daResFlightTypeInternational?: Maybe<Scalars['String']['output']>;
  daResFlightTypeLabel?: Maybe<Scalars['String']['output']>;
  daResPaymentTypeLabel?: Maybe<Scalars['String']['output']>;
  daSidebarCollapseBtn?: Maybe<Scalars['String']['output']>;
  daSidebarExpandBtn?: Maybe<Scalars['String']['output']>;
  daSidebarLogoutBtn?: Maybe<Scalars['String']['output']>;
  daSidebarUserMenuBtn?: Maybe<Scalars['String']['output']>;
  daTripDetailEmpty?: Maybe<Scalars['String']['output']>;
  daUsernameLabel?: Maybe<Scalars['String']['output']>;
  daVehicleDetailEmpty?: Maybe<Scalars['String']['output']>;
  daVehiclePaxLabel?: Maybe<Scalars['String']['output']>;
  defaultTipsLabel?: Maybe<Scalars['String']['output']>;
  genericSubmitError?: Maybe<Scalars['String']['output']>;
  gratuityAddTipLabel?: Maybe<Scalars['String']['output']>;
  gratuityInvalidError?: Maybe<Scalars['String']['output']>;
  gratuityMaxError?: Maybe<Scalars['String']['output']>;
  gratuityMessage?: Maybe<Scalars['String']['output']>;
  gratuityNegativeError?: Maybe<Scalars['String']['output']>;
  gratuityNoTip?: Maybe<Scalars['String']['output']>;
  gratuityRequiredError?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  headerMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  invalidCardNumberError?: Maybe<Scalars['String']['output']>;
  invalidExpirationError?: Maybe<Scalars['String']['output']>;
  invalidUrl?: Maybe<Scalars['String']['output']>;
  landingMessage?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  logo2?: Maybe<Scalars['String']['output']>;
  ratingRangeError?: Maybe<Scalars['String']['output']>;
  requiredError?: Maybe<Scalars['String']['output']>;
  reviewRideTitle?: Maybe<Scalars['String']['output']>;
  routeSeparator?: Maybe<Scalars['String']['output']>;
  serviceAreaName?: Maybe<Scalars['String']['output']>;
  submitButtonLabel?: Maybe<Scalars['String']['output']>;
  successfulSubmitMessage?: Maybe<Scalars['String']['output']>;
  templateErrorFallback?: Maybe<Scalars['String']['output']>;
  templateInputNumericError?: Maybe<Scalars['String']['output']>;
  templateInputRequiredError?: Maybe<Scalars['String']['output']>;
  templateLoadErrorBody?: Maybe<Scalars['String']['output']>;
  templateLoadErrorTitle?: Maybe<Scalars['String']['output']>;
  templateSelectPlaceholder?: Maybe<Scalars['String']['output']>;
  templateSuccessFallback?: Maybe<Scalars['String']['output']>;
};

/** Response type for tokenize mutation */
export type TokenizePayload = MutationResponse & {
  __typename?: 'TokenizePayload';
  /** Credit card expiration date */
  ccExpiration?: Maybe<Scalars['String']['output']>;
  /** Last 4 digits of credit card */
  ccLast4?: Maybe<Scalars['String']['output']>;
  /** Encrypted credit card token */
  ccToken?: Maybe<Scalars['String']['output']>;
  /** General error message */
  error?: Maybe<Scalars['String']['output']>;
  /** Type of error if any */
  errorType?: Maybe<Scalars['String']['output']>;
  /** Human-readable message */
  message?: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type TokenizedCreditCard = {
  __typename?: 'TokenizedCreditCard';
  expiration?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  localId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numberLast4?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  refId?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  tokenType?: Maybe<Scalars['String']['output']>;
  typeCode?: Maybe<Scalars['String']['output']>;
  uniqueId?: Maybe<Scalars['String']['output']>;
};

export enum TopLocationsMode {
  Hide = 'hide',
  Show = 'show'
}

/** A single (id, name) reference-data row inside a translation list. */
export type TranslationEntry = {
  __typename?: 'TranslationEntry';
  /** Raw id verbatim from Bridge (numeric-shaped strings, single-letter codes, etc. — not coerced). */
  id: Scalars['String']['output'];
  /** Human-readable label for the id. */
  name: Scalars['String']['output'];
};

/** A named reference-data list returned by the Bridge translations command. */
export type TranslationList = {
  __typename?: 'TranslationList';
  /** Entries in source order. Empty arrays are legitimate; duplicates are not deduped. */
  entries: Array<TranslationEntry>;
  /** List name as Bridge emits it (camelCase preserved; lowercasing is a client-layer concern). */
  name: Scalars['String']['output'];
};

export type UpdateDriverShiftInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  comments2?: InputMaybe<Scalars['String']['input']>;
  confirmed?: InputMaybe<Scalars['String']['input']>;
  driverId: Scalars['Int']['input'];
  endMilage?: InputMaybe<Scalars['Float']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  scheduledEndTime: Scalars['String']['input'];
  scheduledStartTime: Scalars['String']['input'];
  startLocation?: InputMaybe<Scalars['String']['input']>;
  startMilage?: InputMaybe<Scalars['Float']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
  vehicleId: Scalars['Int']['input'];
  vehicleName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDriverShiftPayload = MutationResponse & {
  __typename?: 'UpdateDriverShiftPayload';
  driverShift?: Maybe<DriverShift>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateUserProfilePayload = MutationResponse & {
  __typename?: 'UpdateUserProfilePayload';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum UserApp {
  /** The driver mobile application */
  DriverApp = 'DriverApp',
  /** The administration web application */
  Hub = 'Hub'
}

export type UserProfileAddCcPayload = MutationResponse & {
  __typename?: 'UserProfileAddCcPayload';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UserProfileAddPudResponse = MutationResponse & {
  __typename?: 'UserProfileAddPudResponse';
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UserProfileAddValpayCcPayload = MutationResponse & {
  __typename?: 'UserProfileAddValpayCcPayload';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UserProfileDeleteCcPayload = MutationResponse & {
  __typename?: 'UserProfileDeleteCcPayload';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UserProfileDeletePudCcPayload = MutationResponse & {
  __typename?: 'UserProfileDeletePudCcPayload';
  /** Error message if the deletion failed */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Type of error that occurred */
  errorType?: Maybe<Scalars['String']['output']>;
  /** General message about the operation result */
  message?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the credit card deletion from PUD was successful */
  success: Scalars['Boolean']['output'];
};

export type UserProfileDeletePudPayload = MutationResponse & {
  __typename?: 'UserProfileDeletePudPayload';
  /** Error message if the deletion failed */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Type of error that occurred */
  errorType?: Maybe<Scalars['String']['output']>;
  /** General message about the operation result */
  message?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the PUD deletion was successful */
  success: Scalars['Boolean']['output'];
};

export type UserProfileExists = {
  __typename?: 'UserProfileExists';
  /** Whether a profile exists for this email */
  exists: Scalars['Boolean']['output'];
  /**
   * Whether the profile has a password set
   * Only meaningful when exists is true
   */
  hasPassword?: Maybe<Scalars['Boolean']['output']>;
  /** Composite ID in format "siteId:email" */
  id: Scalars['ID']['output'];
  /** The profile ID if found */
  profileId?: Maybe<Scalars['Int']['output']>;
};

export type UserProfileLinkGroupPayload = MutationResponse & {
  __typename?: 'UserProfileLinkGroupPayload';
  /** Error message if the link operation failed */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Type of error that occurred */
  errorType?: Maybe<Scalars['String']['output']>;
  /** General message about the operation result */
  message?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the profile link to group was successful */
  success: Scalars['Boolean']['output'];
};

export type UserProfileUpdatePudResponse = MutationResponse & {
  __typename?: 'UserProfileUpdatePudResponse';
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ValidateUserPayload = MutationResponse & {
  __typename?: 'ValidateUserPayload';
  auth?: Maybe<Auth>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  user?: Maybe<ValidatedUser>;
};

export type ValidatedUser = {
  __typename?: 'ValidatedUser';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ValpayConfig = {
  __typename?: 'ValpayConfig';
  /** Client key for frontend Adyen integration */
  clientKey?: Maybe<Scalars['String']['output']>;
  /** Whether Valpay is enabled for the current site/processor combination */
  enabled: Scalars['Boolean']['output'];
  /** Adyen environment: 'test' or 'live' */
  environment?: Maybe<Scalars['String']['output']>;
  /** Error message if configuration or API call failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Composite ID in format: {processor_id}-{shopper_reference}-{response_id} */
  id?: Maybe<Scalars['ID']['output']>;
  /** JSON string containing available payment methods from Adyen */
  paymentMethods?: Maybe<Scalars['String']['output']>;
};

/** Vehicle information */
export type Vehicle = {
  __typename?: 'Vehicle';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

/**
 * Response payload for verifyResForCheckIn mutation.
 * Returns reservation details and check-in options for the user to select from.
 */
export type VerifyResForCheckInPayload = MutationResponse & {
  __typename?: 'VerifyResForCheckInPayload';
  auth?: Maybe<Auth>;
  /** Check-in options including summary for the user to select from */
  checkIn?: Maybe<CheckInOptions>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  /** The verified reservation ID */
  resId?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type VerifyResPayload = MutationResponse & {
  __typename?: 'VerifyResPayload';
  auth?: Maybe<Auth>;
  /** Check-in options including summary (returned when appName supports check-in) */
  checkIn?: Maybe<CheckInOptions>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  resId?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

/** GPS waypoint data for vehicles and drivers */
export type Waypoint = {
  __typename?: 'Waypoint';
  driver?: Maybe<Driver>;
  heading?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  position?: Maybe<LatLng>;
  recordedTime?: Maybe<Scalars['String']['output']>;
  speed?: Maybe<Scalars['Int']['output']>;
  vehicle?: Maybe<Vehicle>;
};

/** Filter for waypoint queries */
export type WaypointFilterInput = {
  field: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type BridgesQueryVariables = Exact<{ [key: string]: never; }>;


export type BridgesQuery = { __typename?: 'Query', bridges: Array<{ __typename?: 'Bridge', id: string, address: string, parentId?: number | null, portNumber: number, server: string, serviceName: string, siteIds?: Array<string> | null, status?: string | null, lastCheckTime?: string | null, bridgeType?: number | null, exiVersion?: number | null, exiRestartTOD?: string | null, log: Array<{ __typename?: 'BridgeLog', status: string, message?: string | null, time: string }> }> };

export type ClearBridgeCacheMutationVariables = Exact<{
  input: ClearBridgeCacheInput;
}>;


export type ClearBridgeCacheMutation = { __typename?: 'Mutation', clearBridgeCache: { __typename?: 'ClearBridgeCacheResponse', success: boolean, message?: string | null, errorType?: string | null, command: string, siteId: string } };

export type ColorsQueryVariables = Exact<{ [key: string]: never; }>;


export type ColorsQuery = { __typename?: 'Query', colors?: { __typename?: 'Colors', id: string, primaryColor: string, primaryHover: string, primaryText: string } | null };

export type ContentQueryVariables = Exact<{
  tokenGroup: Scalars['String']['input'];
  serviceAreaId?: InputMaybe<Scalars['Int']['input']>;
  showToken?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ContentQuery = { __typename?: 'Query', content?: { __typename?: 'TokenContent', beAddressDetailsLabel?: string | null, beAirlineLabel?: string | null, beAltphoneLabel?: string | null, beApplyCouponButton?: string | null, beApplyCouponLabel?: string | null, beAutocompleteMoreOptionsButton?: string | null, beBagsDescription?: string | null, beBagsHeader?: string | null, beBagsLabel?: string | null, beBagsUrl?: string | null, beBagsUrlLabel?: string | null, beBookButton?: string | null, beBookAnotherButton?: string | null, beBookHeaderButton?: string | null, beBookReturnTripDescription?: string | null, beBookReturnTripLabel?: string | null, beBookLoadingMsg?: string | null, beBookingInfoSectionHeader?: string | null, beCancelButton?: string | null, beCancelConfirmationCancelButton?: string | null, beCancelConfirmationMsg?: string | null, beCancelResSuccess?: string | null, beCanceledMsg?: string | null, beCcAddressLabel?: string | null, beCcCvvLabel?: string | null, beCcExpLabel?: string | null, beCcNameLabel?: string | null, beCcNumberLabel?: string | null, beCcPostalcodeLabel?: string | null, beChangepwPasswordLabel?: string | null, beChangepwNewPasswordLabel?: string | null, beChangepwSubmitButton?: string | null, beChangepwSuccessMsg?: string | null, beCheckoutTitle?: string | null, beConfirmDialogDefaultCancelButton?: string | null, beConfirmDialogDefaultTitle?: string | null, beConfirmationHead?: string | null, beConfirmationTitle?: string | null, beContactGuestCheckout?: string | null, beContactPassengersHeader?: string | null, beContactPassengersNameLabel?: string | null, beContactPassengersText?: string | null, beContactSectionTitle?: string | null, beContinueButton?: string | null, beContinueToCcPageButton?: string | null, beConvertOpenButton?: string | null, beConvertOpenCancelButton?: string | null, beConvertOpenCancelConfirmation?: string | null, beConvertOpenMessage?: string | null, beConvertOpenSuccessMessage?: string | null, beCouponAppliedMsg?: string | null, beCreateNewAccountButton?: string | null, beCreateNewAccountTitle?: string | null, beCrossStreetLabel?: string | null, beCustRequestFlightTime?: string | null, beCustRequestPickupTime?: string | null, beDropoffDirectionsLabel?: string | null, beDropoffLocLabel?: string | null, beEditBackButton?: string | null, beEditStopDialogConfirmButton?: string | null, beEditStopDialogConfirmMessage?: string | null, beEditResidPrefix?: string | null, beEditLegButton?: string | null, beEditOpenResButton?: string | null, beEditResButton?: string | null, beEmailLabel?: string | null, beEmailProfileCheckLoginButton?: string | null, beEmailProfileCheckMsg?: string | null, beEpicPassAppliedMsg?: string | null, beEpicPassIdLabel?: string | null, beErrEpicLogin?: string | null, beEpicPassSubmitBtn?: string | null, beErrAltphone?: string | null, beErrAltphoneFormat?: string | null, beErrAirline?: string | null, beErrBadCoupon?: string | null, beErrBagCountMax?: string | null, beErrCantVerify?: string | null, beErrCcAddress?: string | null, beErrCcCvv?: string | null, beErrCcExp?: string | null, beErrCcName?: string | null, beErrCcNumber?: string | null, beErrCcPostalcode?: string | null, beErrCcNumberInvalid?: string | null, beErrCcNumberType?: string | null, beErrEmail?: string | null, beErrEmailFormat?: string | null, beErrStopsComments?: string | null, beErrStopsName?: string | null, beErrStopsReprice?: string | null, beErrFaxNumberFormat?: string | null, beErrFieldRequired?: string | null, beErrFlightCityDepartures?: string | null, beErrFlightCityArrivals?: string | null, beErrFlightNumArrivals?: string | null, beErrFlightNumDepartures?: string | null, beErrGroupLogin?: string | null, beErrGroupPasswordLogin?: string | null, beErrLinkedGroups?: string | null, beErrLocTooGeneral?: string | null, beErrLookupEmailFormat?: string | null, beErrMarketingCode?: string | null, beErrMaxPassengers?: string | null, beErrName?: string | null, beErrNoFareKey?: string | null, beErrNoPickuptimes?: string | null, beErrNoService?: string | null, beErrNoServiceTitle?: string | null, beErrPassengers?: string | null, beErrProfileCcAdd?: string | null, beErrProfileCcRemove?: string | null, beErrProfileLocationsAdd?: string | null, beErrProfileLocationsDelete?: string | null, beErrProfileLocationsUpdate?: string | null, beErrPasswordMinLength?: string | null, beErrPasswordUpdate?: string | null, beErrPhone?: string | null, beErrPhoneFormat?: string | null, beErrProfileUpdate?: string | null, beErrPudPersonCcRemove?: string | null, beErrNoLocsFound?: string | null, beErrNoLocsFoundFixed?: string | null, beErrResNotCanceled?: string | null, beErrResNotConverted?: string | null, beErrResetpwGeneral?: string | null, beErrSessionExpired?: string | null, beErrSpecialInfoMin?: string | null, beErrSpecialInstr?: string | null, beErrSystemError?: string | null, beErrTerms?: string | null, beErrUserLogin?: string | null, beErrUsernameBad?: string | null, beExternalCcMessage?: string | null, beExtraStopLabel?: string | null, beFaxNumberLabel?: string | null, beFirstLegHeader?: string | null, beFlightCityArrivalsLabel?: string | null, beFlightCityDeparturesLabel?: string | null, beFlightDateLabel?: string | null, beFlightDateArrLabel?: string | null, beFlightDateDepLabel?: string | null, beFlightNumberLabel?: string | null, beFlightSectionTitle?: string | null, beFlightSectionFlightSubtitle?: string | null, beFlightSectionExtrasSubtitle?: string | null, beFlightTimeLabel?: string | null, beFlightTimeArrLabel?: string | null, beFlightTimeDepLabel?: string | null, beFlightTypeInternationalLabel?: string | null, beForgotPwButton?: string | null, beFrpBookAnotherButton?: string | null, beFrpBookButton?: string | null, beFrpBookLoadingMsg?: string | null, beFrpButton?: string | null, beFrpConfirmationHead?: string | null, beFrpConfirmationTitle?: string | null, beFrpFreeRides?: string | null, beFrpGoodThru?: string | null, beFrpNoPrograms?: string | null, beFrpQuantityLabel?: string | null, beFrpSubmitBtn?: string | null, beFrpStartDateLabel?: string | null, beGroupLoginCodeLabel?: string | null, beGroupLoginSubmitBtn?: string | null, beGroupLoginPrompt?: string | null, beGroupLogoutLabel?: string | null, beGratuityIncludedMsg?: string | null, beGratuityRtGratuityIsLabel?: string | null, beGratuitySectionGrpSvcContent?: string | null, beGratuitySectionTitle?: string | null, beGratuityZeroDefaultLabel?: string | null, beGroupPasswordLabel?: string | null, beGroupLoginSubmitButton?: string | null, beGroupPwBackButton?: string | null, beHeaderProfileButton?: string | null, beLocAmenIconH?: string | null, beLocAmenIconNP?: string | null, beLocAmenIconP?: string | null, beLocAmenIconR?: string | null, beLocAmenIconV?: string | null, beLocationDialogCommonCatsHeader?: string | null, beLocationDialogTopLocHeader?: string | null, beLocationSectionTitle?: string | null, beLocationStringLabel?: string | null, beLocationtypeNamePuds?: string | null, beLoginSubmitButton?: string | null, beLoginTitle?: string | null, beLogoutButton?: string | null, beLogoutConfirmationButton?: string | null, beLogoutConfirmationMsg?: string | null, beLogoutConfirmationTitle?: string | null, beMadeByLabel?: string | null, beMakeOneWayResButton?: string | null, beManageTripsButton?: string | null, beMapPopupLinkLabel?: string | null, beMarketingCodeLabel?: string | null, beNameLabel?: string | null, beNearbyLocsAway?: string | null, beNearbyLocsFeet?: string | null, beNearbyLocsHeaderMsgLocAvailable?: string | null, beNearbyLocsHeaderMsgLocNotAvailable?: string | null, beNearbyLocsMiles?: string | null, beNearbyLocsHeaderPrefix?: string | null, beNearbyLocsSectHeaderNearbyLocs?: string | null, beNearbyLocsSectHeaderReqLoc?: string | null, beNearbyLocsSectSubheadNearbyLocs?: string | null, beNearbyLocsSectSubheadReqLoc?: string | null, beNewProfileBackButton?: string | null, beNewProfileSubmitButton?: string | null, beNewProfileTitle?: string | null, beNewTotalLabel?: string | null, bePaginationOf?: string | null, bePassengersHeader?: string | null, bePasswordAriaHide?: string | null, bePasswordAriaShow?: string | null, bePasswordLabel?: string | null, bePaymentCcDialogSaveButton?: string | null, bePaymentCcDialogTitle?: string | null, bePaymentCcDifferentCardLabel?: string | null, bePaymentCcTokenizedEndingIn?: string | null, bePaymentCcTokenizedExpires?: string | null, bePaymentPaidWithPoints?: string | null, bePaymentRemoveButton?: string | null, bePaymentSectionTitle?: string | null, bePaymentCcSectionTitle?: string | null, bePaymentDbSectionTitle?: string | null, bePaymentDirectbillPayment?: string | null, bePaymentnotesCc?: string | null, bePaymentnotesFr?: string | null, bePhoneLabel?: string | null, bePickupDateLabel?: string | null, bePickupDirectionsLabel?: string | null, bePickupTimeLabel?: string | null, bePickupLocLabel?: string | null, bePickupTimeArrive?: string | null, bePickupTimeFlightHours?: string | null, bePickupTimeFlightMinutes?: string | null, bePickupTimeFlightPreArr?: string | null, bePickupTimeFlightPreDep?: string | null, bePickupTimeFlightSufArr?: string | null, bePickupTimeFlightSufDep?: string | null, bePickupTimeAvailableSeats?: string | null, bePickupTimeOffPeak?: string | null, bePickupTimeShortNotice?: string | null, bePickupTimeShowAdtlTimes?: string | null, bePickupTimeShowButton?: string | null, bePickuptimeSectionTitle?: string | null, bePointsDontUsePtsLabel?: string | null, bePointsNumPointsLabel?: string | null, bePointsNewTotalLabel?: string | null, bePointsPointsAvailSfx?: string | null, bePointsSectionTitle?: string | null, beProfileAccountButton?: string | null, beProfileAltphoneLabel?: string | null, beProfileCcAddSubmitButton?: string | null, beProfileCcAddSuccessMsg?: string | null, beProfileCcAddTitle?: string | null, beProfileCcRemoveDialogMessage?: string | null, beProfileCcRemoveDialogSubmitButton?: string | null, beProfileCcRemoveDialogTitle?: string | null, beProfileCcRemoveSuccessMsg?: string | null, beProfileCcSavedCardsTitle?: string | null, beProfileContactSectionTitle?: string | null, beProfileContactTab?: string | null, beProfileEmailLabel?: string | null, beProfilePointsTab?: string | null, beProfilePointsTableResidPrefix?: string | null, beProfilePointsTitle?: string | null, beProfilePointsTransactionsTitle?: string | null, beProfileHomeTitle?: string | null, beProfileLgLabelClientid?: string | null, beProfileLgLabelGroupid?: string | null, beProfileLgLabelWebid?: string | null, beProfileLinkedGroupsCancelButton?: string | null, beProfileLinkedGroupsChangeButton?: string | null, beProfileLinkedGroupsSubmitButton?: string | null, beProfileLinkedGroupsSuccessMsg?: string | null, beProfileLinkedGroupsTab?: string | null, beProfileLinkedGroupsTitle?: string | null, beProfileLinkedGroupsValidatedLabel?: string | null, beProfileLocationsAddButton?: string | null, beProfileLocationsAddSuccess?: string | null, beProfileLocationsDeleteSuccess?: string | null, beProfileLocationsEditButton?: string | null, beProfileLocationsFieldLabel?: string | null, beProfileLocationsNewLocSubmitButton?: string | null, beProfileLocationsNewUpdateLocCancelButton?: string | null, beProfileLocationsNewLocTitle?: string | null, beProfileLocationsRemoveButton?: string | null, beProfileLocationsRemoveDialogConfirmButton?: string | null, beProfileLocationsRemoveDialogConfirmMessage?: string | null, beProfileLocationsRemoveDialogCancelButton?: string | null, beProfileLocationsRemoveDialogTitle?: string | null, beProfileLocationsTab?: string | null, beProfileLocationsTitle?: string | null, beProfileLocationsUpdateLocSubmitButton?: string | null, beProfileLocationsUpdateLocTitle?: string | null, beProfileLocationsUpdateSuccess?: string | null, beProfileNameLabel?: string | null, beProfileUpdateSubmitButton?: string | null, beProfileUpdateSuccessMsg?: string | null, beProfilePasswordLabel?: string | null, beProfilePasswordTitle?: string | null, beProfilePhoneLabel?: string | null, beReferralsHead?: string | null, beRemoveCouponLabel?: string | null, beRemoveLegButton?: string | null, beProfilePaymentTab?: string | null, beProfilePasswordTab?: string | null, beProfileReservationsTab?: string | null, beProfileResNoResMessage?: string | null, beProfileResNoResMessageTitle?: string | null, beProfileResOpenTab?: string | null, beProfileResPastTab?: string | null, beProfileResUpcomingTab?: string | null, beProfileResViewDetailsButton?: string | null, beProfileResViewDetailsOpenButton?: string | null, bePudPersonLabel?: string | null, bePudPersonContactSectionTitle?: string | null, bePudPersonAltphoneLabel?: string | null, bePudPersonCcRemoveDialogMessage?: string | null, bePudPersonCcRemoveDialogSubmitButton?: string | null, bePudPersonCcRemoveDialogTitle?: string | null, bePudPersonCcRemoveSuccessMsg?: string | null, bePudPersonCcSectionTitle?: string | null, bePudPersonEmailLabel?: string | null, bePudPersonFaxLabel?: string | null, bePudPersonNameLabel?: string | null, bePudPersonPhoneLabel?: string | null, beRequiredPlaceholder?: string | null, beResetpwContent?: string | null, beResetpwNewPasswordLabel?: string | null, beResetpwSubmitButton?: string | null, beResetpwSuccessMsg?: string | null, beResetpwTitle?: string | null, beReslookupHead?: string | null, beReslookupResnumLabel?: string | null, beReslookupValidationTypeLabel?: string | null, beReslookupValidationValueLabel?: string | null, beRessummaryAmountPaidLabel?: string | null, beRessummaryBackButton?: string | null, beRessummaryDirectbillPayment?: string | null, beRessummaryHead?: string | null, beRessummaryCancelledLabel?: string | null, beRessummaryFlightSectionTitle?: string | null, beRessummaryPickupAtLabel?: string | null, beRessummaryPointsUsedLabel?: string | null, beRessummaryTotalLabel?: string | null, beSelectNoOptions?: string | null, beSendResetpwBackButton?: string | null, beSendResetpwContent?: string | null, beSendResetpwSubmitButton?: string | null, beSendResetpwSuccessMsg?: string | null, beSendResetpwTitle?: string | null, beServiceExtraEachLabel?: string | null, beServiceExtrasHeader?: string | null, beServicePsgrsMaximum?: string | null, beServiceSelectButton?: string | null, beServiceStartingAt?: string | null, beSidebarHeader?: string | null, beSidebarResidLabel?: string | null, beSidebarPointsUsedLabel?: string | null, beSidebarTotalLabel?: string | null, beSpecialInstrLabel?: string | null, beSrvextraSelectBlank?: string | null, beStopsAddButton?: string | null, beStopsCommentsLabel?: string | null, beStopsHeader?: string | null, beStopsNameLabel?: string | null, beStopsNotAllowed?: string | null, beStopsRemoveButton?: string | null, beStopsSectionTitle?: string | null, beStopsStopPrefix?: string | null, beSuggestcreateConfirm?: string | null, beSuggestcreateContent?: string | null, beSuggestcreateSaveButton?: string | null, beSuggestcreateTitle?: string | null, beSuggestloginContent?: string | null, beSuggestloginLoginButton?: string | null, beSuggestloginTitle?: string | null, beReturnTripHeader?: string | null, beTermsConditionsLabel?: string | null, beTermsConditionsUrl?: string | null, beTermsConditionsUrlLabel?: string | null, beUsernameLabel?: string | null, beVarianceNegativeLabel?: string | null, beVariancePositiveLabel?: string | null, beVarianceZero?: string | null, beWebSubfareACaption?: string | null, beWebSubfareBCaption?: string | null, beWebSubfareCCaption?: string | null, beWebSubfareDCaption?: string | null, beWebSubfareECaption?: string | null, beWebSubfaresContent?: string | null, beWebSubfaresHeader?: string | null, beWebSubfareSummary?: string | null, daErrFieldRequired?: string | null, daErrSystemError?: string | null, daErrorDialogOkBtn?: string | null, daLoginSubmitButton?: string | null, daLoginTitle?: string | null, daPasswordLabel?: string | null, daRequiredPlaceholder?: string | null, daUsernameLabel?: string | null } | null };

export type LoginUserMutationVariables = Exact<{
  username: Scalars['String']['input'];
  password: Scalars['String']['input'];
  appType: UserApp;
}>;


export type LoginUserMutation = { __typename?: 'Mutation', loginUser?: { __typename?: 'LoginUserPayload', errorType?: string | null, success: boolean, message?: string | null, auth?: { __typename?: 'Auth', token?: string | null } | null } | null };

export type ValpayConfigQueryVariables = Exact<{
  processorId?: InputMaybe<Scalars['Int']['input']>;
  shopperReference?: InputMaybe<Scalars['String']['input']>;
}>;


export type ValpayConfigQuery = { __typename?: 'Query', valpayConfig: { __typename?: 'ValpayConfig', id?: string | null, clientKey?: string | null, enabled: boolean, environment?: string | null, error?: string | null, paymentMethods?: string | null } };


export const BridgesDocument = gql`
    query bridges {
  bridges {
    id
    address
    parentId
    portNumber
    server
    serviceName
    siteIds
    status
    lastCheckTime
    bridgeType
    exiVersion
    exiRestartTOD
    log {
      status
      message
      time
    }
  }
}
    `;

/**
 * __useBridgesQuery__
 *
 * To run a query within a React component, call `useBridgesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBridgesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBridgesQuery({
 *   variables: {
 *   },
 * });
 */
export function useBridgesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BridgesQuery, BridgesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BridgesQuery, BridgesQueryVariables>(BridgesDocument, options);
      }
export function useBridgesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BridgesQuery, BridgesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BridgesQuery, BridgesQueryVariables>(BridgesDocument, options);
        }
export function useBridgesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BridgesQuery, BridgesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BridgesQuery, BridgesQueryVariables>(BridgesDocument, options);
        }
export type BridgesQueryHookResult = ReturnType<typeof useBridgesQuery>;
export type BridgesLazyQueryHookResult = ReturnType<typeof useBridgesLazyQuery>;
export type BridgesSuspenseQueryHookResult = ReturnType<typeof useBridgesSuspenseQuery>;
export type BridgesQueryResult = Apollo.QueryResult<BridgesQuery, BridgesQueryVariables>;
export const ClearBridgeCacheDocument = gql`
    mutation ClearBridgeCache($input: ClearBridgeCacheInput!) {
  clearBridgeCache(input: $input) {
    success
    message
    errorType
    command
    siteId
  }
}
    `;
export type ClearBridgeCacheMutationFn = Apollo.MutationFunction<ClearBridgeCacheMutation, ClearBridgeCacheMutationVariables>;

/**
 * __useClearBridgeCacheMutation__
 *
 * To run a mutation, you first call `useClearBridgeCacheMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearBridgeCacheMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearBridgeCacheMutation, { data, loading, error }] = useClearBridgeCacheMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClearBridgeCacheMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ClearBridgeCacheMutation, ClearBridgeCacheMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ClearBridgeCacheMutation, ClearBridgeCacheMutationVariables>(ClearBridgeCacheDocument, options);
      }
export type ClearBridgeCacheMutationHookResult = ReturnType<typeof useClearBridgeCacheMutation>;
export type ClearBridgeCacheMutationResult = Apollo.MutationResult<ClearBridgeCacheMutation>;
export type ClearBridgeCacheMutationOptions = Apollo.BaseMutationOptions<ClearBridgeCacheMutation, ClearBridgeCacheMutationVariables>;
export const ColorsDocument = gql`
    query Colors {
  colors {
    id
    primaryColor
    primaryHover
    primaryText
  }
}
    `;

/**
 * __useColorsQuery__
 *
 * To run a query within a React component, call `useColorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useColorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useColorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useColorsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ColorsQuery, ColorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ColorsQuery, ColorsQueryVariables>(ColorsDocument, options);
      }
export function useColorsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ColorsQuery, ColorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ColorsQuery, ColorsQueryVariables>(ColorsDocument, options);
        }
export function useColorsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ColorsQuery, ColorsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ColorsQuery, ColorsQueryVariables>(ColorsDocument, options);
        }
export type ColorsQueryHookResult = ReturnType<typeof useColorsQuery>;
export type ColorsLazyQueryHookResult = ReturnType<typeof useColorsLazyQuery>;
export type ColorsSuspenseQueryHookResult = ReturnType<typeof useColorsSuspenseQuery>;
export type ColorsQueryResult = Apollo.QueryResult<ColorsQuery, ColorsQueryVariables>;
export const ContentDocument = gql`
    query content($tokenGroup: String!, $serviceAreaId: Int, $showToken: Boolean) {
  content(
    tokenGroup: $tokenGroup
    serviceAreaId: $serviceAreaId
    showToken: $showToken
  ) {
    beAddressDetailsLabel
    beAirlineLabel
    beAltphoneLabel
    beApplyCouponButton
    beApplyCouponLabel
    beAutocompleteMoreOptionsButton
    beBagsDescription
    beBagsHeader
    beBagsLabel
    beBagsUrl
    beBagsUrlLabel
    beBookButton
    beBookAnotherButton
    beBookHeaderButton
    beBookReturnTripDescription
    beBookReturnTripLabel
    beBookLoadingMsg
    beBookingInfoSectionHeader
    beCancelButton
    beCancelConfirmationCancelButton
    beCancelConfirmationMsg
    beCancelResSuccess
    beCanceledMsg
    beCcAddressLabel
    beCcCvvLabel
    beCcExpLabel
    beCcNameLabel
    beCcNumberLabel
    beCcPostalcodeLabel
    beChangepwPasswordLabel
    beChangepwNewPasswordLabel
    beChangepwSubmitButton
    beChangepwSuccessMsg
    beCheckoutTitle
    beConfirmDialogDefaultCancelButton
    beConfirmDialogDefaultTitle
    beConfirmationHead
    beConfirmationTitle
    beContactGuestCheckout
    beContactPassengersHeader
    beContactPassengersNameLabel
    beContactPassengersText
    beContactSectionTitle
    beContinueButton
    beContinueToCcPageButton
    beConvertOpenButton
    beConvertOpenCancelButton
    beConvertOpenCancelConfirmation
    beConvertOpenMessage
    beConvertOpenSuccessMessage
    beCouponAppliedMsg
    beCreateNewAccountButton
    beCreateNewAccountTitle
    beCrossStreetLabel
    beCustRequestFlightTime
    beCustRequestPickupTime
    beDropoffDirectionsLabel
    beDropoffLocLabel
    beEditBackButton
    beEditStopDialogConfirmButton
    beEditStopDialogConfirmMessage
    beEditResidPrefix
    beEditLegButton
    beEditOpenResButton
    beEditResButton
    beEmailLabel
    beEmailProfileCheckLoginButton
    beEmailProfileCheckMsg
    beEpicPassAppliedMsg
    beEpicPassIdLabel
    beErrEpicLogin
    beEpicPassSubmitBtn
    beErrAltphone
    beErrAltphoneFormat
    beErrAirline
    beErrBadCoupon
    beErrBagCountMax
    beErrCantVerify
    beErrCcAddress
    beErrCcCvv
    beErrCcExp
    beErrCcName
    beErrCcNumber
    beErrCcPostalcode
    beErrCcNumberInvalid
    beErrCcNumberType
    beErrEmail
    beErrEmailFormat
    beErrStopsComments
    beErrStopsName
    beErrStopsReprice
    beErrFaxNumberFormat
    beErrFieldRequired
    beErrFlightCityDepartures
    beErrFlightCityArrivals
    beErrFlightNumArrivals
    beErrFlightNumDepartures
    beErrGroupLogin
    beErrGroupPasswordLogin
    beErrLinkedGroups
    beErrLocTooGeneral
    beErrLookupEmailFormat
    beErrMarketingCode
    beErrMaxPassengers
    beErrName
    beErrNoFareKey
    beErrNoPickuptimes
    beErrNoService
    beErrNoServiceTitle
    beErrPassengers
    beErrProfileCcAdd
    beErrProfileCcRemove
    beErrProfileLocationsAdd
    beErrProfileLocationsDelete
    beErrProfileLocationsUpdate
    beErrPasswordMinLength
    beErrPasswordUpdate
    beErrPhone
    beErrPhoneFormat
    beErrProfileUpdate
    beErrPudPersonCcRemove
    beErrNoLocsFound
    beErrNoLocsFoundFixed
    beErrResNotCanceled
    beErrResNotConverted
    beErrResetpwGeneral
    beErrSessionExpired
    beErrSpecialInfoMin
    beErrSpecialInstr
    beErrSystemError
    beErrTerms
    beErrUserLogin
    beErrUsernameBad
    beExternalCcMessage
    beExtraStopLabel
    beFaxNumberLabel
    beFirstLegHeader
    beFlightCityArrivalsLabel
    beFlightCityDeparturesLabel
    beFlightDateLabel
    beFlightDateArrLabel
    beFlightDateDepLabel
    beFlightNumberLabel
    beFlightSectionTitle
    beFlightSectionFlightSubtitle
    beFlightSectionExtrasSubtitle
    beFlightTimeLabel
    beFlightTimeArrLabel
    beFlightTimeDepLabel
    beFlightTypeInternationalLabel
    beForgotPwButton
    beFrpBookAnotherButton
    beFrpBookButton
    beFrpBookLoadingMsg
    beFrpButton
    beFrpConfirmationHead
    beFrpConfirmationTitle
    beFrpFreeRides
    beFrpGoodThru
    beFrpNoPrograms
    beFrpQuantityLabel
    beFrpSubmitBtn
    beFrpStartDateLabel
    beGroupLoginCodeLabel
    beGroupLoginSubmitBtn
    beGroupLoginPrompt
    beGroupLogoutLabel
    beGratuityIncludedMsg
    beGratuityRtGratuityIsLabel
    beGratuitySectionGrpSvcContent
    beGratuitySectionTitle
    beGratuityZeroDefaultLabel
    beGroupPasswordLabel
    beGroupLoginSubmitButton
    beGroupPwBackButton
    beHeaderProfileButton
    beLocAmenIconH
    beLocAmenIconNP
    beLocAmenIconP
    beLocAmenIconR
    beLocAmenIconV
    beLocationDialogCommonCatsHeader
    beLocationDialogTopLocHeader
    beLocationSectionTitle
    beLocationStringLabel
    beLocationtypeNamePuds
    beLoginSubmitButton
    beLoginTitle
    beLogoutButton
    beLogoutConfirmationButton
    beLogoutConfirmationMsg
    beLogoutConfirmationTitle
    beMadeByLabel
    beMakeOneWayResButton
    beManageTripsButton
    beMapPopupLinkLabel
    beMarketingCodeLabel
    beNameLabel
    beNearbyLocsAway
    beNearbyLocsFeet
    beNearbyLocsHeaderMsgLocAvailable
    beNearbyLocsHeaderMsgLocNotAvailable
    beNearbyLocsMiles
    beNearbyLocsHeaderPrefix
    beNearbyLocsSectHeaderNearbyLocs
    beNearbyLocsSectHeaderReqLoc
    beNearbyLocsSectSubheadNearbyLocs
    beNearbyLocsSectSubheadReqLoc
    beNewProfileBackButton
    beNewProfileSubmitButton
    beNewProfileTitle
    beNewTotalLabel
    bePaginationOf
    bePassengersHeader
    bePasswordAriaHide
    bePasswordAriaShow
    bePasswordLabel
    bePaymentCcDialogSaveButton
    bePaymentCcDialogTitle
    bePaymentCcDifferentCardLabel
    bePaymentCcTokenizedEndingIn
    bePaymentCcTokenizedExpires
    bePaymentPaidWithPoints
    bePaymentRemoveButton
    bePaymentSectionTitle
    bePaymentCcSectionTitle
    bePaymentDbSectionTitle
    bePaymentDirectbillPayment
    bePaymentnotesCc
    bePaymentnotesFr
    bePhoneLabel
    bePickupDateLabel
    bePickupDirectionsLabel
    bePickupTimeLabel
    bePickupLocLabel
    bePickupTimeArrive
    bePickupTimeFlightHours
    bePickupTimeFlightMinutes
    bePickupTimeFlightPreArr
    bePickupTimeFlightPreDep
    bePickupTimeFlightSufArr
    bePickupTimeFlightSufDep
    bePickupTimeAvailableSeats
    bePickupTimeOffPeak
    bePickupTimeShortNotice
    bePickupTimeShowAdtlTimes
    bePickupTimeShowButton
    bePickuptimeSectionTitle
    bePointsDontUsePtsLabel
    bePointsNumPointsLabel
    bePointsNewTotalLabel
    bePointsPointsAvailSfx
    bePointsSectionTitle
    beProfileAccountButton
    beProfileAltphoneLabel
    beProfileCcAddSubmitButton
    beProfileCcAddSuccessMsg
    beProfileCcAddTitle
    beProfileCcRemoveDialogMessage
    beProfileCcRemoveDialogSubmitButton
    beProfileCcRemoveDialogTitle
    beProfileCcRemoveSuccessMsg
    beProfileCcSavedCardsTitle
    beProfileContactSectionTitle
    beProfileContactTab
    beProfileEmailLabel
    beProfilePointsTab
    beProfilePointsTableResidPrefix
    beProfilePointsTitle
    beProfilePointsTransactionsTitle
    beProfileHomeTitle
    beProfileLgLabelClientid
    beProfileLgLabelGroupid
    beProfileLgLabelWebid
    beProfileLinkedGroupsCancelButton
    beProfileLinkedGroupsChangeButton
    beProfileLinkedGroupsSubmitButton
    beProfileLinkedGroupsSuccessMsg
    beProfileLinkedGroupsTab
    beProfileLinkedGroupsTitle
    beProfileLinkedGroupsValidatedLabel
    beProfileLocationsAddButton
    beProfileLocationsAddSuccess
    beProfileLocationsDeleteSuccess
    beProfileLocationsEditButton
    beProfileLocationsFieldLabel
    beProfileLocationsNewLocSubmitButton
    beProfileLocationsNewUpdateLocCancelButton
    beProfileLocationsNewLocTitle
    beProfileLocationsRemoveButton
    beProfileLocationsRemoveDialogConfirmButton
    beProfileLocationsRemoveDialogConfirmMessage
    beProfileLocationsRemoveDialogCancelButton
    beProfileLocationsRemoveDialogTitle
    beProfileLocationsTab
    beProfileLocationsTitle
    beProfileLocationsUpdateLocSubmitButton
    beProfileLocationsUpdateLocTitle
    beProfileLocationsUpdateSuccess
    beProfileNameLabel
    beProfileUpdateSubmitButton
    beProfileUpdateSuccessMsg
    beProfilePasswordLabel
    beProfilePasswordTitle
    beProfilePhoneLabel
    beReferralsHead
    beRemoveCouponLabel
    beRemoveLegButton
    beProfilePaymentTab
    beProfilePasswordTab
    beProfileReservationsTab
    beProfileResNoResMessage
    beProfileResNoResMessageTitle
    beProfileResOpenTab
    beProfileResPastTab
    beProfileResUpcomingTab
    beProfileResViewDetailsButton
    beProfileResViewDetailsOpenButton
    bePudPersonLabel
    bePudPersonContactSectionTitle
    bePudPersonAltphoneLabel
    bePudPersonCcRemoveDialogMessage
    bePudPersonCcRemoveDialogSubmitButton
    bePudPersonCcRemoveDialogTitle
    bePudPersonCcRemoveSuccessMsg
    bePudPersonCcSectionTitle
    bePudPersonEmailLabel
    bePudPersonFaxLabel
    bePudPersonNameLabel
    bePudPersonPhoneLabel
    beRequiredPlaceholder
    beResetpwContent
    beResetpwNewPasswordLabel
    beResetpwSubmitButton
    beResetpwSuccessMsg
    beResetpwTitle
    beReslookupHead
    beReslookupResnumLabel
    beReslookupValidationTypeLabel
    beReslookupValidationValueLabel
    beRessummaryAmountPaidLabel
    beRessummaryBackButton
    beRessummaryDirectbillPayment
    beRessummaryHead
    beRessummaryCancelledLabel
    beRessummaryFlightSectionTitle
    beRessummaryPickupAtLabel
    beRessummaryPointsUsedLabel
    beRessummaryTotalLabel
    beSelectNoOptions
    beSendResetpwBackButton
    beSendResetpwContent
    beSendResetpwSubmitButton
    beSendResetpwSuccessMsg
    beSendResetpwTitle
    beServiceExtraEachLabel
    beServiceExtrasHeader
    beServicePsgrsMaximum
    beServiceSelectButton
    beServiceStartingAt
    beSidebarHeader
    beSidebarResidLabel
    beSidebarPointsUsedLabel
    beSidebarTotalLabel
    beSpecialInstrLabel
    beSrvextraSelectBlank
    beStopsAddButton
    beStopsCommentsLabel
    beStopsHeader
    beStopsNameLabel
    beStopsNotAllowed
    beStopsRemoveButton
    beStopsSectionTitle
    beStopsStopPrefix
    beSuggestcreateConfirm
    beSuggestcreateContent
    beSuggestcreateSaveButton
    beSuggestcreateTitle
    beSuggestloginContent
    beSuggestloginLoginButton
    beSuggestloginTitle
    beReturnTripHeader
    beTermsConditionsLabel
    beTermsConditionsUrl
    beTermsConditionsUrlLabel
    beUsernameLabel
    beVarianceNegativeLabel
    beVariancePositiveLabel
    beVarianceZero
    beWebSubfareACaption
    beWebSubfareBCaption
    beWebSubfareCCaption
    beWebSubfareDCaption
    beWebSubfareECaption
    beWebSubfaresContent
    beWebSubfaresHeader
    beWebSubfareSummary
    daErrFieldRequired
    daErrSystemError
    daErrorDialogOkBtn
    daLoginSubmitButton
    daLoginTitle
    daPasswordLabel
    daRequiredPlaceholder
    daUsernameLabel
  }
}
    `;

/**
 * __useContentQuery__
 *
 * To run a query within a React component, call `useContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentQuery({
 *   variables: {
 *      tokenGroup: // value for 'tokenGroup'
 *      serviceAreaId: // value for 'serviceAreaId'
 *      showToken: // value for 'showToken'
 *   },
 * });
 */
export function useContentQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ContentQuery, ContentQueryVariables> & ({ variables: ContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ContentQuery, ContentQueryVariables>(ContentDocument, options);
      }
export function useContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ContentQuery, ContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ContentQuery, ContentQueryVariables>(ContentDocument, options);
        }
export function useContentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ContentQuery, ContentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ContentQuery, ContentQueryVariables>(ContentDocument, options);
        }
export type ContentQueryHookResult = ReturnType<typeof useContentQuery>;
export type ContentLazyQueryHookResult = ReturnType<typeof useContentLazyQuery>;
export type ContentSuspenseQueryHookResult = ReturnType<typeof useContentSuspenseQuery>;
export type ContentQueryResult = Apollo.QueryResult<ContentQuery, ContentQueryVariables>;
export const LoginUserDocument = gql`
    mutation loginUser($username: String!, $password: String!, $appType: UserApp!) {
  loginUser(username: $username, password: $password, appType: $appType) {
    errorType
    success
    message
    auth {
      token
    }
  }
}
    `;
export type LoginUserMutationFn = Apollo.MutationFunction<LoginUserMutation, LoginUserMutationVariables>;

/**
 * __useLoginUserMutation__
 *
 * To run a mutation, you first call `useLoginUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginUserMutation, { data, loading, error }] = useLoginUserMutation({
 *   variables: {
 *      username: // value for 'username'
 *      password: // value for 'password'
 *      appType: // value for 'appType'
 *   },
 * });
 */
export function useLoginUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LoginUserMutation, LoginUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LoginUserMutation, LoginUserMutationVariables>(LoginUserDocument, options);
      }
export type LoginUserMutationHookResult = ReturnType<typeof useLoginUserMutation>;
export type LoginUserMutationResult = Apollo.MutationResult<LoginUserMutation>;
export type LoginUserMutationOptions = Apollo.BaseMutationOptions<LoginUserMutation, LoginUserMutationVariables>;
export const ValpayConfigDocument = gql`
    query valpayConfig($processorId: Int, $shopperReference: String) {
  valpayConfig(processorId: $processorId, shopperReference: $shopperReference) {
    id
    clientKey
    enabled
    environment
    error
    paymentMethods
  }
}
    `;

/**
 * __useValpayConfigQuery__
 *
 * To run a query within a React component, call `useValpayConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useValpayConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValpayConfigQuery({
 *   variables: {
 *      processorId: // value for 'processorId'
 *      shopperReference: // value for 'shopperReference'
 *   },
 * });
 */
export function useValpayConfigQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ValpayConfigQuery, ValpayConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ValpayConfigQuery, ValpayConfigQueryVariables>(ValpayConfigDocument, options);
      }
export function useValpayConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ValpayConfigQuery, ValpayConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ValpayConfigQuery, ValpayConfigQueryVariables>(ValpayConfigDocument, options);
        }
export function useValpayConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ValpayConfigQuery, ValpayConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ValpayConfigQuery, ValpayConfigQueryVariables>(ValpayConfigDocument, options);
        }
export type ValpayConfigQueryHookResult = ReturnType<typeof useValpayConfigQuery>;
export type ValpayConfigLazyQueryHookResult = ReturnType<typeof useValpayConfigLazyQuery>;
export type ValpayConfigSuspenseQueryHookResult = ReturnType<typeof useValpayConfigSuspenseQuery>;
export type ValpayConfigQueryResult = Apollo.QueryResult<ValpayConfigQuery, ValpayConfigQueryVariables>;